(() => {
  if (window.allSixRefreshLoaded) return;
  window.allSixRefreshLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');

  const parallaxMedia = Array.from(
    document.querySelectorAll(
      '.banner__media img, .image-with-text__media img, .slideshow__media img'
    )
  );

  parallaxMedia.forEach((image) => image.classList.add('as-parallax-media'));

  let ticking = false;

  const updateParallax = () => {
    ticking = false;

    if (reduceMotion.matches || !desktop.matches) {
      parallaxMedia.forEach((image) => image.style.removeProperty('--as-parallax-y'));
      return;
    }

    parallaxMedia.forEach((image) => {
      const frame = image.parentElement;
      if (!frame) return;
      const bounds = frame.getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;

      const centerOffset = bounds.top + bounds.height / 2 - window.innerHeight / 2;
      const movement = Math.max(-28, Math.min(28, centerOffset * -0.045));
      image.style.setProperty('--as-parallax-y', `${movement.toFixed(2)}px`);
    });
  };

  const requestParallax = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  };

  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax);
  reduceMotion.addEventListener('change', requestParallax);
  desktop.addEventListener('change', requestParallax);
  requestParallax();

  const bookingDrawer = document.querySelector('[data-booking-drawer]');

  if (!bookingDrawer) return;

  const bookingPanel = bookingDrawer.querySelector('.as-booking-drawer__panel');
  const bookingSteps = Array.from(bookingDrawer.querySelectorAll('[data-booking-step]'));
  const bookingProgress = Array.from(bookingDrawer.querySelectorAll('[data-booking-progress]'));
  const bookingProviderButtons = Array.from(bookingDrawer.querySelectorAll('[data-booking-provider]'));
  const bookingServiceTypeList = bookingDrawer.querySelector('[data-booking-service-type-list]');
  const bookingTypeStatus = bookingDrawer.querySelector('[data-booking-type-status]');
  const bookingCategoryList = bookingDrawer.querySelector('[data-booking-category-list]');
  const bookingServiceSearch = bookingDrawer.querySelector('[data-booking-service-search]');
  const bookingServiceStatus = bookingDrawer.querySelector('[data-booking-service-status]');
  const bookingServiceList = bookingDrawer.querySelector('[data-booking-service-list]');
  const bookingSelectedService = bookingDrawer.querySelector('[data-booking-selected-service]');
  const bookingSegmentList = bookingDrawer.querySelector('[data-booking-segment-list]');
  const bookingAddOnList = bookingDrawer.querySelector('[data-booking-addon-list]');
  const bookingProviderPanel = bookingDrawer.querySelector('[data-booking-provider-panel]');
  const bookingProviderList = bookingDrawer.querySelector('[data-booking-provider-list]');
  const bookingEntryModeButtons = Array.from(bookingDrawer.querySelectorAll('[data-booking-entry-mode]'));
  const bookingServiceTools = bookingDrawer.querySelector('[data-booking-service-tools]');
  const bookingProviderFilter = bookingDrawer.querySelector('[data-booking-provider-filter]');
  const bookingProviderFilterList = bookingDrawer.querySelector('[data-booking-provider-filter-list]');
  const bookingProviderFilterStatus = bookingDrawer.querySelector('[data-booking-provider-filter-status]');
  const bookingSegmentProviderList = bookingDrawer.querySelector('[data-booking-segment-provider-list]');
  const bookingProviderStatus = bookingDrawer.querySelector('[data-booking-provider-status]');
  const bookingDate = bookingDrawer.querySelector('[data-booking-date]');
  const bookingDatePrev = bookingDrawer.querySelector('[data-booking-date-prev]');
  const bookingDateNext = bookingDrawer.querySelector('[data-booking-date-next]');
  const bookingDateList = bookingDrawer.querySelector('[data-booking-date-list]');
  const bookingSearchTimes = bookingDrawer.querySelector('[data-booking-search-times]');
  const bookingAvailabilityStatus = bookingDrawer.querySelector('[data-booking-availability-status]');
  const bookingAvailabilityActions = bookingDrawer.querySelector('[data-booking-availability-actions]');
  const bookingSlotList = bookingDrawer.querySelector('[data-booking-slot-list]');
  const bookingSummary = bookingDrawer.querySelector('[data-booking-summary]');
  const bookingReview = bookingDrawer.querySelector('[data-booking-review]');
  const bookingReviewStatus = bookingDrawer.querySelector('[data-booking-review-status]');
  const bookingConfirmation = bookingDrawer.querySelector('[data-booking-confirmation]');
  const bookingFirstName = bookingDrawer.querySelector('[data-booking-first-name]');
  const bookingLastName = bookingDrawer.querySelector('[data-booking-last-name]');
  const bookingPhone = bookingDrawer.querySelector('[data-booking-phone]');
  const bookingEmail = bookingDrawer.querySelector('[data-booking-email]');
  const bookingNotes = bookingDrawer.querySelector('[data-booking-notes]');
  const bookingCardholderName = bookingDrawer.querySelector('[data-booking-cardholder-name]');
  const bookingPolicyConfirm = bookingDrawer.querySelector('[data-booking-policy-confirm]');
  const bookingMarketingConfirm = bookingDrawer.querySelector('[data-booking-marketing-confirm]');
  const bookingPaymentStatus = bookingDrawer.querySelector('[data-booking-payment-status]');
  const bookingCardPolicy = bookingDrawer.querySelector('[data-booking-card-policy]');
  const bookingCardShell = bookingDrawer.querySelector('[data-booking-card-shell]');
  const bookingCardContainer = bookingDrawer.querySelector('[data-booking-card-container]');
  const bookingVariationModal = bookingDrawer.querySelector('[data-booking-variation-modal]');
  const bookingVariationTitle = bookingDrawer.querySelector('[data-booking-variation-title]');
  const bookingVariationKicker = bookingDrawer.querySelector('[data-booking-variation-kicker]');
  const bookingVariationList = bookingDrawer.querySelector('[data-booking-variation-list]');
  const bookingEditServices = bookingDrawer.querySelector('[data-booking-edit-services]');
  const bookingBack = bookingDrawer.querySelector('[data-booking-back]');
  const bookingNext = bookingDrawer.querySelector('[data-booking-next]');
  const fallbackBookingUrl = bookingDrawer.dataset.squareFallback || '#';
  const publicBookingMode = String(bookingDrawer.dataset.bookingMode || 'square').trim().toLowerCase();
  const publicDrawerEnabled = bookingDrawer.dataset.drawerEnabled === 'true' && publicBookingMode === 'drawer';
  const editorPreviewEnabled = bookingDrawer.dataset.bookingEditorPreview === 'true' && publicDrawerEnabled;
  const configApiUrl = bookingDrawer.dataset.configApi || '';
  const servicesApiUrl = bookingDrawer.dataset.servicesApi || '';
  const teamApiUrl = bookingDrawer.dataset.teamApi || '';
  const servicesAssetUrl = bookingDrawer.dataset.servicesUrl || '';
  const availabilityApiUrl = bookingDrawer.dataset.availabilityApi || '';
  const createApiUrl = bookingDrawer.dataset.createApi || '';
  let bookingStep = 0;
  let bookingCatalog = { services: [], categories: [], fallbackBookingUrl };
  let bookingCatalogPromise = null;
  let bookingConfigPromise = null;
  let bookingConfig = null;
  let bookingTeam = { team: [{ id: 'any', label: 'Any available staff', bookable: true }] };
  let bookingTeamPromise = null;
  let bookingCatalogSource = 'loading';
  let selectedCategories = new Set();
  let selectedService = null;
  let selectedAddOns = new Set();
  let visitItems = [];
  let selectedProviderMode = 'first_available';
  let selectedProviderId = 'any';
  let serviceEntryMode = 'services';
  let serviceProviderFilterIds = new Set();
  let rememberedServiceProviderFilterIds = [];
  let selectedProvidersBySegment = {};
  let selectedProvidersByItem = {};
  let selectedSlot = null;
  let selectedSlotsByItem = {};
  let selectedSlotsByDate = {};
  let bookingSlots = [];
  let bookingSlotsByItem = {};
  let availabilitySearchSignature = '';
  let availabilitySearchActive = false;
  let nextAvailableSearchActive = false;
  let activeBookingDateValue = '';
  let activeVariationChooser = null;
  let bookingReturnFocus = null;
  let squarePayments = null;
  let squareCard = null;
  let squareCardPromise = null;
  let squareCardReady = false;
  let squareToken = '';
  let squareVerificationToken = '';
  let squareCardInputState = {};
  let bookingCreated = false;
  let bookingCreateActive = false;
  let cardholderNameTouched = false;

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const cleanLower = (value) => cleanText(value).toLowerCase();
  const compactText = (value) => cleanLower(value).replace(/[^a-z0-9]/g, '');
  const publicStaffName = (member = {}) => {
    const firstName = cleanText(member.firstName || member.first_name || member.givenName || member.given_name);
    const label = cleanText(member.displayName || member.display_name || member.name || member.label || 'Staff');
    const safeLabel = label || 'Staff';

    if (firstName) return firstName;
    if (/^(any|any available staff|staff\s+\d+)$/i.test(safeLabel)) return safeLabel;

    const displayLabel = cleanText(safeLabel
      .replace(/\s*\([^)]*\)\s*/g, ' ')
      .replace(/\s+-\s+.*$/, ' ')
      .replace(/\s+\/\s+.*$/, ' '));

    return displayLabel.split(/\s+/)[0] || safeLabel || 'Staff';
  };
  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[character]);
  const genericSquareCardError = (message) => /unexpected error occurred while using card/i.test(message);
  const squareErrorObjects = (source = {}) => [
    ...Array.isArray(source.squareErrors) ? source.squareErrors : [],
    ...Array.isArray(source.errors) ? source.errors : [],
  ];
  const squareErrorCodes = (source = {}) => [
    source.code,
    source.squareCode,
    source.status,
    source.squareStatus,
    ...squareErrorObjects(source).flatMap((error) => [error?.code, error?.type, error?.category, error?.field, error?.message, error?.detail]),
  ].map((value) => cleanText(value).toUpperCase()).filter(Boolean);
  const squareErrorTextSignal = (source = {}) => cleanLower([
    source.message,
    source.error,
    source.detail,
    source.title,
    ...squareErrorObjects(source).flatMap((error) => [error?.field, error?.message, error?.detail, error?.type, error?.code]),
  ].filter(Boolean).join(' '));
  const hasSquareErrorCode = (source, patterns) => {
    const codes = squareErrorCodes(source).join(' ');
    return patterns.some((pattern) => codes.includes(pattern));
  };
  const sourceErrorFieldMatches = (source = {}, fields = []) => {
    const normalizedFields = fields.map(compactText);
    return squareErrorObjects(source).some((error) => {
      const signals = [error?.field, error?.message, error?.detail, error?.type, error?.code].map(compactText);
      return normalizedFields.some((field) => signals.some((signal) => signal.includes(field)));
    });
  };
  const currentCardFieldMatches = (fields = []) => {
    const currentField = compactText(squareCardInputState.field);
    return Boolean(currentField && fields.some((field) => currentField === compactText(field)));
  };
  const tokenizationLooksLikeField = (source = {}, fields = []) =>
    genericSquareCardError(source.message || source.error || '') &&
    cleanText(source.squareSource || source.source) === 'Card.tokenize()' &&
    squareCardInputState.hasErrorClass === true &&
    currentCardFieldMatches(fields);
  const tokenizationLooksPostal = (source = {}) =>
    tokenizationLooksLikeField(source, ['postalCode']);
  const tokenizationLooksCvv = (source = {}) =>
    tokenizationLooksLikeField(source, ['cvv']);
  const tokenizationLooksExpiration = (source = {}) =>
    tokenizationLooksLikeField(source, ['expirationDate']);
  const tokenizationLooksCardNumber = (source = {}) =>
    tokenizationLooksLikeField(source, ['cardNumber']);
  const existingClientPaymentMessage = (source = {}) => {
    const message = cleanText(source.clientMessage || source.message || source.error || '');
    return /^(The billing ZIP code|The CVV|The expiration date|The card details|This card has insufficient funds|The card was declined|The secure card session|This secure card session)/.test(message)
      ? message
      : '';
  };
  const squareClientPaymentMessage = (source = {}, fallback = 'Square could not complete that request.') => {
    const existingMessage = existingClientPaymentMessage(source);
    if (existingMessage) return existingMessage;

    if (
      hasSquareErrorCode(source, ['ADDRESS_VERIFICATION_FAILURE', 'VERIFY_AVS_FAILURE', 'INVALID_POSTAL_CODE']) ||
      sourceErrorFieldMatches(source, ['postalCode', 'postal', 'zip']) ||
      tokenizationLooksPostal(source)
    ) {
      return 'The billing ZIP code does not match the card. Please check the ZIP code and try again.';
    }

    if (
      hasSquareErrorCode(source, ['CVV_FAILURE', 'VERIFY_CVV_FAILURE']) ||
      sourceErrorFieldMatches(source, ['cvv']) ||
      tokenizationLooksCvv(source)
    ) {
      return 'The CVV does not match the card. Please check the CVV and try again.';
    }

    if (
      hasSquareErrorCode(source, ['CARD_EXPIRED', 'INVALID_EXPIRATION', 'EXPIRATION_FAILURE', 'BAD_EXPIRATION']) ||
      sourceErrorFieldMatches(source, ['expirationDate', 'expiration', 'expiry']) ||
      tokenizationLooksExpiration(source)
    ) {
      return 'The expiration date does not look right. Please check the date and try again.';
    }

    if (
      hasSquareErrorCode(source, ['PAN_FAILURE', 'INVALID_CARD', 'INVALID_CARD_DATA']) ||
      sourceErrorFieldMatches(source, ['cardNumber', 'pan']) ||
      tokenizationLooksCardNumber(source)
    ) {
      return 'The card details could not be verified. Please check the card number and try again.';
    }

    if (hasSquareErrorCode(source, ['INSUFFICIENT_FUNDS'])) {
      return 'This card has insufficient funds. Please use another card.';
    }

    if (hasSquareErrorCode(source, ['CARD_DECLINED_CALL_ISSUER'])) {
      return 'The card was declined. Please call the card issuer or use another card.';
    }

    if (hasSquareErrorCode(source, ['CARD_DECLINED', 'GENERIC_DECLINE', 'CARD_DECLINED_VERIFICATION_REQUIRED'])) {
      return 'The card was declined. Please use another card or contact the card issuer.';
    }

    if (hasSquareErrorCode(source, ['SOURCE_EXPIRED', 'CARD_TOKEN_EXPIRED'])) {
      return 'The secure card session expired. Please re-enter the card details.';
    }

    if (hasSquareErrorCode(source, ['SOURCE_USED', 'CARD_TOKEN_USED'])) {
      return 'This secure card session was already used. Please re-enter the card details.';
    }

    const fallbackText = cleanText(fallback);
    const sourceText = cleanText([source.message, source.error, source.detail, source.title].filter(Boolean).join(' '));
    const signalText = squareErrorTextSignal(source);
    if (
      genericSquareCardError(sourceText) ||
      signalText.includes('unexpectederror') ||
      /could not secure this card|could not store this card|card tokenization failed|card on file|tokenize/i.test(`${sourceText} ${fallbackText}`) ||
      hasSquareErrorCode(source, ['INVALID', 'UNKNOWN'])
    ) {
      return 'Square could not verify this card. Please use another card.';
    }

    return fallbackText;
  };
  const squareThrownError = (error, squareSource = '') => {
    const message = cleanText(error?.message || error);
    const isGenericCardError = genericSquareCardError(message);
    const errorName = cleanText(error?.name);

    return {
      message,
      error: message,
      code: cleanText(error?.code || (errorName && errorName !== 'Error' ? errorName : '') || (isGenericCardError ? 'CARD_SDK_ERROR' : '')),
      status: cleanText(error?.status || error?.statusCode || (isGenericCardError ? 'SDK_EXCEPTION' : '')),
      errors: Array.isArray(error?.errors) ? error.errors : Array.isArray(error?.details) ? error.details : [],
      squareSource,
    };
  };
  const squareErrorMessage = (source = {}, fallback = 'Square could not complete that request.') => {
    return squareClientPaymentMessage(source, fallback);
  };
  const squareDisplayError = (source = {}, fallback) => {
    const error = new Error(squareErrorMessage(source, fallback));
    error.clientMessage = error.message;
    error.squareErrors = source.squareErrors || source.errors || [];
    error.squareStatus = source.status || source.squareStatus || '';
    error.squareCode = source.code || source.squareCode || '';
    error.squareSource = source.squareSource || source.source || '';
    return error;
  };
  const setPaymentStatus = (message, detail = {}) => {
    if (!bookingPaymentStatus) return;
    bookingPaymentStatus.textContent = cleanText(message);
    const code = cleanText(detail.squareCode || detail.code || '');
    const status = cleanText(detail.squareStatus || detail.status || '');
    const isError = Boolean(detail.clientMessage || detail.squareErrors?.length || detail.squareCode || detail.code || detail instanceof Error);

    if (code) bookingPaymentStatus.dataset.squareErrorCode = code;
    else delete bookingPaymentStatus.dataset.squareErrorCode;

    if (status) bookingPaymentStatus.dataset.squareErrorStatus = status;
    else delete bookingPaymentStatus.dataset.squareErrorStatus;

    bookingPaymentStatus.dataset.paymentState = isError ? 'error' : 'neutral';
  };
  const setReviewStatus = (message = '', state = 'neutral') => {
    if (!bookingReviewStatus) return;
    const text = cleanText(message);

    bookingReviewStatus.textContent = text;
    bookingReviewStatus.hidden = !text;
    if (text) bookingReviewStatus.dataset.reviewState = cleanText(state) || 'neutral';
    else delete bookingReviewStatus.dataset.reviewState;
  };
  const focusBookingConfirmation = () => {
    if (!bookingConfirmation || bookingConfirmation.hidden) return;
    bookingConfirmation.setAttribute('tabindex', '-1');
    window.requestAnimationFrame(() => {
      bookingConfirmation.scrollIntoView({
        block: 'start',
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
      bookingConfirmation.focus({ preventScroll: true });
    });
  };
  const paymentStatusIsError = () => bookingPaymentStatus?.dataset.paymentState === 'error';
  const clearStalePaymentError = (message = 'Card details updated. Continue when ready.') => {
    if (!paymentStatusIsError()) return;
    setPaymentStatus(message);
  };
  const updateSquareCardInputState = (eventName, event) => {
    const detail = event?.detail || event || {};
    const field = cleanText(detail.field);
    const eventType = cleanText(detail.eventType || eventName);
    const isPostalEvent = compactText(eventType).includes('postal') || compactText(field) === 'postalcode';
    const postalCodeValue = cleanText(detail.postalCodeValue);
    const currentState = detail.currentState || {};

    squareCardInputState = {
      ...squareCardInputState,
      eventType,
      field: field || squareCardInputState.field || '',
      postalCodeValue: isPostalEvent ? postalCodeValue : cleanText(squareCardInputState.postalCodeValue),
      hasErrorClass: Boolean(currentState.hasErrorClass),
      isCompletelyValid: Boolean(currentState.isCompletelyValid),
      isPotentiallyValid: Boolean(currentState.isPotentiallyValid),
    };

    squareToken = '';
    squareVerificationToken = '';
    if (bookingCreated) return;
    clearStalePaymentError('Card details updated. Continue when ready.');
    setFooterState();
  };

  const dateInputValue = (date) => {
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) return '';
    value.setMinutes(value.getMinutes() - value.getTimezoneOffset());
    return value.toISOString().slice(0, 10);
  };

  const todayValue = () => dateInputValue(new Date());
  const defaultBookingDateValue = () => todayValue();

  const formatDuration = (minutes) => {
    const value = Number(minutes || 0);

    if (!Number.isFinite(value) || value <= 0) return '';
    if (value < 60) return `${value} min`;

    const hours = Math.floor(value / 60);
    const remaining = value % 60;

    return remaining ? `${hours} hr ${remaining} min` : `${hours} hr`;
  };

  const formatMoneyCents = (cents, currency = 'USD') => {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(value / 100);
    } catch {
      return `$${(value / 100).toFixed(2)}`;
    }
  };

  const numericCandidate = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const numeric = typeof value === 'number' ? value : Number(String(value).replace(/[$,\s]/g, ''));
    return Number.isFinite(numeric) ? numeric : null;
  };

  const centsFromMoney = (money = {}) => {
    if (money === undefined || money === null || money === '') return null;
    if (typeof money !== 'object') return numericCandidate(money);
    const candidates = [
      money.amount,
      money.amountCents,
      money.amount_cents,
      money.cents,
      money.value,
      money.centAmount,
      money.cent_amount,
    ];
    return candidates.map(numericCandidate).find((value) => value !== null) ?? null;
  };

  const centsFromText = (value = '') => {
    const text = cleanText(value);
    if (!text || /see\s+square/i.test(text) || /varies|variable|by design/i.test(text)) return null;
    if (/\$?\s*\d+(?:,\d{3})*(?:\.\d{1,2})?\s*(?:-|–|\bto\b)\s*\$?\s*\d+/i.test(text)) {
      return null;
    }
    const match = text.match(/\$?\s*([0-9]{1,3}(?:,[0-9]{3})*|[0-9]+)(?:\.([0-9]{1,2}))?/);
    if (!match) return null;
    const amount = Number(`${match[1].replace(/,/g, '')}${match[2] ? `.${match[2]}` : ''}`);
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  };

  const serviceVariationMoneyCandidates = (service = {}) => {
    const fromVariations = (variations = []) => (
      Array.isArray(variations)
        ? variations.flatMap((variation = {}) => [
            variation.priceMoney,
            variation.price_money,
            variation.itemVariationData?.priceMoney,
            variation.itemVariationData?.price_money,
            variation.item_variation_data?.priceMoney,
            variation.item_variation_data?.price_money,
          ])
        : []
    );
    return [
      ...fromVariations(service.variations),
      ...fromVariations(service.itemData?.variations),
      ...fromVariations(service.item_data?.variations),
    ];
  };

  const serviceMoneyCandidates = (service = {}) => [
    service.priceMoney,
    service.price_money,
    service.amountMoney,
    service.amount_money,
    service.basePriceMoney,
    service.base_price_money,
    service.itemVariationData?.priceMoney,
    service.itemVariationData?.price_money,
    service.item_variation_data?.priceMoney,
    service.item_variation_data?.price_money,
    service.variation?.priceMoney,
    service.variation?.price_money,
    service.variation?.itemVariationData?.priceMoney,
    service.variation?.itemVariationData?.price_money,
    service.variation?.item_variation_data?.priceMoney,
    service.variation?.item_variation_data?.price_money,
    ...serviceVariationMoneyCandidates(service),
  ];

  const servicePriceText = (service = {}) => (
    [
      service.formattedPrice,
      service.formatted_price,
      service.startingPrice,
      service.starting_price,
      service.price,
      service.priceLabel,
      service.price_label,
      service.displayPrice,
      service.display_price,
      service.pricingLabel,
      service.pricing_label,
      service.variation?.formattedPrice,
      service.variation?.formatted_price,
      service.variation?.price,
      service.itemVariationData?.formattedPrice,
      service.itemVariationData?.formatted_price,
      service.item_variation_data?.formattedPrice,
      service.item_variation_data?.formatted_price,
    ]
      .map(cleanText)
      .find((value) => value && !/see\s+square/i.test(value)) || ''
  );

  const servicePriceCents = (service = {}) => {
    const direct = [
      service.priceCents,
      service.price_cents,
      service.totalCents,
      service.total_cents,
      service.subtotalCents,
      service.subtotal_cents,
      service.amountCents,
      service.amount_cents,
    ].map(numericCandidate).find((value) => value !== null);
    if (direct !== undefined) return direct;

    const moneyAmount = serviceMoneyCandidates(service)
      .map(centsFromMoney)
      .find((value) => value !== null);
    if (moneyAmount !== undefined) return moneyAmount;

    return centsFromText(servicePriceText(service));
  };

  const serviceCurrency = (service = {}) => {
    const moneyCurrency = serviceMoneyCandidates(service)
      .map((money) => cleanText(money?.currency))
      .find(Boolean);
    return cleanText(service.currency || moneyCurrency || 'USD') || 'USD';
  };

  const serviceDisplayPrice = (service = {}) => {
    const cents = servicePriceCents(service);
    if (cents !== null) return formatMoneyCents(cents, serviceCurrency(service));
    const value = servicePriceText(service);
    if (!value) return 'Price varies';
    if (/varies|variable|by design/i.test(value)) return 'Price varies';
    return value;
  };

  const visitPricingSummary = () => {
    const items = selectedLineItems();
    const pricedItems = items.map((item) => {
      const cents = servicePriceCents(item.service);
      return {
        item,
        cents,
        currency: serviceCurrency(item.service),
        label: serviceDisplayPrice(item.service) || 'Final price at appointment',
      };
    });
    const currencies = [...new Set(pricedItems.map((entry) => entry.currency).filter(Boolean))];
    const currency = currencies.length === 1 ? currencies[0] : 'USD';
    const allFixed = pricedItems.length > 0 && pricedItems.every((entry) => entry.cents !== null);
    const subtotalCents = allFixed ? pricedItems.reduce((total, entry) => total + entry.cents, 0) : null;
    const taxCents = allFixed ? 0 : null;
    const totalCents = allFixed ? subtotalCents + taxCents : null;
    const hasVariablePricing = pricedItems.some((entry) => entry.cents === null);

    return {
      items: pricedItems,
      currency,
      subtotalCents,
      taxCents,
      totalCents,
      dueTodayCents: allFixed ? 0 : null,
      dueAtAppointmentCents: totalCents,
      allFixed,
      hasVariablePricing,
    };
  };

  const formatDateTime = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(date);
  };

  const formatTimeOnly = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric',
      minute: '2-digit',
    }).format(date);
  };

  const formatCardBrand = (brand = '') => {
    const value = cleanText(brand).replace(/_/g, ' ').toLowerCase();
    if (!value) return 'Card';
    return value.replace(/\b[a-z]/g, (character) => character.toUpperCase());
  };

  const dateFromInputValue = (value) => {
    const parts = cleanText(value || defaultBookingDateValue()).split('-').map(Number);
    if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) return new Date(`${defaultBookingDateValue()}T00:00:00`);
    return new Date(parts[0], parts[1] - 1, parts[2]);
  };

  const addDaysToDateValue = (value, days) => {
    const date = dateFromInputValue(value);
    date.setDate(date.getDate() + days);
    return dateInputValue(date);
  };

  const dateParts = (date) => ({
    weekday: new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date),
    month: new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date),
    day: new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(date),
  });

  const idempotencyKey = (prefix) => {
    if (window.crypto?.randomUUID) return `${prefix}-${window.crypto.randomUUID()}`;
    return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  };

  const dayRange = (value) => {
    const date = value || defaultBookingDateValue();
    const start = new Date(`${date}T00:00:00`);
    const end = new Date(start);
    end.setDate(start.getDate() + 1);
    return {
      startAt: start.toISOString(),
      endAt: end.toISOString(),
    };
  };

  const catalogServices = () => (Array.isArray(bookingCatalog.services) ? bookingCatalog.services : []);
  const serviceBySlug = (slug) => catalogServices().find((service) => service.slug === slug) || null;
  const selectedCategoryList = () => Array.from(selectedCategories);

  const createVisitItemId = () => {
    const suffix = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    return `visit-${suffix}`;
  };

  const selectedLineItems = () => visitItems
    .map((item, index) => {
      const service = serviceBySlug(item.serviceSlug);
      return service ? { ...item, service, index } : null;
    })
    .filter(Boolean);

  const selectedServiceSlugs = () => selectedLineItems().map((item) => item.service.slug);

  const selectedServices = () => selectedLineItems().map((item) => item.service);

  const serviceTaxonomyText = (service = {}) => cleanLower([
    service.category,
    service.title,
    service.slug,
    service.customerDescription,
    service.description,
    Array.isArray(service.segments)
      ? service.segments.map((segment) => [segment.title, segment.name].filter(Boolean).join(' ')).join(' ')
      : '',
  ].filter(Boolean).join(' '));

  const serviceHasTerms = (service = {}, terms = []) => {
    const text = serviceTaxonomyText(service);
    return terms.some((term) => text.includes(term));
  };

  const serviceIsNail = (service = {}) =>
    serviceHasTerms(service, ['nail', 'manicure', 'pedicure', 'gel-x', 'gel x', 'apres', 'aprex']);

  const serviceIsManicure = (service = {}) =>
    serviceHasTerms(service, ['manicure', 'mani']);

  const serviceIsPedicure = (service = {}) =>
    serviceHasTerms(service, ['pedicure', 'pedi']);

  const serviceIsNailAddon = (service = {}) => {
    const text = serviceTaxonomyText(service);
    return serviceIsNail(service) && /(?:\badd\s?-?\s?on\b|\baddon\b|\brepair\b|\bremoval\b|\bsoak off\b|\bfix\b)/i.test(text);
  };

  const serviceBlocksNailOverlap = (service = {}) =>
    serviceHasTerms(service, ['facial', 'hydrafacial', 'lash', 'eyelash', 'brow', 'eyebrow']);

  const serviceCanCombineWith = (firstService = {}, secondService = {}) => {
    const firstCombinations = Array.isArray(firstService.canCombineWith) ? firstService.canCombineWith.map(cleanText) : [];
    const secondCombinations = Array.isArray(secondService.canCombineWith) ? secondService.canCombineWith.map(cleanText) : [];
    const firstSlug = cleanText(firstService.slug);
    const secondSlug = cleanText(secondService.slug);

    return Boolean(
      (secondSlug && firstCombinations.includes(secondSlug)) ||
      (firstSlug && secondCombinations.includes(firstSlug)),
    );
  };

  const servicesCanOverlap = (firstService = {}, secondService = {}) => {
    const firstSlug = cleanText(firstService.slug);
    const secondSlug = cleanText(secondService.slug);

    if (!firstSlug || !secondSlug) return false;
    if (serviceIsNailAddon(firstService) || serviceIsNailAddon(secondService)) return false;
    if (serviceCanCombineWith(firstService, secondService)) return true;

    const firstNail = serviceIsNail(firstService);
    const secondNail = serviceIsNail(secondService);

    if (
      (firstNail && serviceBlocksNailOverlap(secondService)) ||
      (secondNail && serviceBlocksNailOverlap(firstService))
    ) {
      return false;
    }

    if (firstSlug === secondSlug) return true;

    if (firstNail && secondNail) {
      return (
        (serviceIsManicure(firstService) && serviceIsPedicure(secondService)) ||
        (serviceIsPedicure(firstService) && serviceIsManicure(secondService))
      );
    }

    return false;
  };

  const syncSelectedService = () => {
    selectedService = selectedLineItems()[0]?.service || null;
  };

  const selectedLineCountForService = (slug = '') =>
    selectedLineItems().filter((item) => item.service.slug === slug).length;

  const addVisitItemForService = (service) => {
    if (!service) return;
    visitItems = [
      ...visitItems,
      {
        id: createVisitItemId(),
        serviceSlug: service.slug,
        addedAt: Date.now(),
      },
    ];
  };

  const removeLastVisitItemForService = (serviceSlug = '') => {
    const slug = cleanText(serviceSlug);
    if (!slug) return;
    const index = visitItems.map((item) => item.serviceSlug).lastIndexOf(slug);
    if (index < 0) return;
    const [removed] = visitItems.splice(index, 1);
    if (!removed?.id) return;
    delete selectedProvidersByItem[removed.id];
    removeSlotSelectionForItem(removed.id);
    delete bookingSlotsByItem[removed.id];
  };

  const uniqueValues = (values = []) => [...new Set(values.filter(Boolean))];

  const serviceProviderIds = (service = {}) => uniqueValues([
    ...(Array.isArray(service.compatibleProviderIds) ? service.compatibleProviderIds : []),
    ...(Array.isArray(service.allowedTeamMemberIds) ? service.allowedTeamMemberIds : []),
    ...(Array.isArray(service.teamMemberIds) ? service.teamMemberIds : []),
    ...(Array.isArray(service.segments)
      ? service.segments.flatMap((segment) => segment.compatibleProviderIds || segment.allowedTeamMemberIds || [])
      : []),
  ].map(cleanText));

  const serviceAllowsProvider = (service = {}, providerId = '') => {
    const provider = cleanText(providerId);
    const compatible = serviceProviderIds(service);

    return !provider || provider === 'any' || !compatible.length || compatible.includes(provider);
  };

  const serviceIsPubliclyBookable = (service = {}) =>
    Boolean(
      service?.slug &&
      service?.title &&
      service.onlineBookable !== false &&
      service.bookable !== false &&
      service.isBookable !== false &&
      service.squareConfigured !== false &&
      serviceProviderIds(service).length,
    );

  const fallbackTeamMembers = () => {
    const ids = uniqueValues(catalogServices().flatMap(serviceProviderIds));

    return ids.map((id, index) => ({
      id,
      label: `Staff ${index + 1}`,
      bookable: true,
    }));
  };

  const teamMembers = () => {
    const fromPayload = Array.isArray(bookingTeam.team) ? bookingTeam.team : [];
    const hasSquareTeam = bookingTeam.state === 'square' && fromPayload.some((member) => cleanText(member.id || member.teamMemberId) && cleanText(member.id || member.teamMemberId) !== 'any');
    const members = [
      { id: 'any', label: 'Any available staff', bookable: true },
      ...fromPayload,
      ...(hasSquareTeam ? [] : fallbackTeamMembers()),
    ];
    const seen = new Set();

    return members
      .map((member) => ({
        id: cleanText(member.id || member.teamMemberId),
        label: publicStaffName(member),
        bookable: member.bookable !== false,
      }))
      .filter((member) => member.id && !seen.has(member.id) && seen.add(member.id))
      .filter((member) => member.id === 'any' || member.bookable !== false);
  };

  const concreteTeamMembers = () => teamMembers().filter((member) => member.id !== 'any');
  const providerName = (providerId = '') => {
    const id = cleanText(providerId);
    if (!id || id === 'any') return 'Any available staff';
    return teamMembers().find((member) => member.id === id)?.label || 'Staff';
  };

  const providerSlug = (provider = {}) =>
    cleanLower(provider.slug || provider.handle || provider.label || provider.name || '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const activeServiceProviderFilterIds = () => [
    ...serviceProviderFilterIds,
  ].map(cleanText).filter((id) => id && id !== 'any');

  const storedServiceProviderFilterIds = () => uniqueValues(
    cleanText(bookingDrawer.dataset.bookingPreferredProviderIds || '')
      .split(',')
      .map(cleanText)
      .filter((id) => id && id !== 'any'),
  );

  const setRememberedServiceProviderFilterIds = (ids = []) => {
    const nextIds = uniqueValues(ids.map(cleanText).filter((id) => id && id !== 'any'));
    rememberedServiceProviderFilterIds = nextIds;
    if (nextIds.length) {
      bookingDrawer.dataset.bookingPreferredProviderIds = nextIds.join(',');
    } else {
      delete bookingDrawer.dataset.bookingPreferredProviderIds;
    }
    return nextIds;
  };

  const effectiveServiceProviderFilterIds = () => {
    const activeIds = uniqueValues(activeServiceProviderFilterIds());
    if (activeIds.length) {
      return setRememberedServiceProviderFilterIds(activeIds);
    }

    const storedIds = storedServiceProviderFilterIds();
    if (storedIds.length) {
      return setRememberedServiceProviderFilterIds(storedIds);
    }

    if (serviceEntryMode !== 'providers') return [];

    return setRememberedServiceProviderFilterIds(
      rememberedServiceProviderFilterIds.map(cleanText).filter((id) => id && id !== 'any'),
    );
  };

  const activeServiceProviderFilterId = () => {
    return effectiveServiceProviderFilterIds()[0] || '';
  };

  const formatProviderList = (ids = []) => {
    const names = ids.map(providerName).filter(Boolean);
    if (!names.length) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} and ${names[1]}`;
    return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
  };

  const providerFromLink = (link) => {
    if (!link) return null;
    const idHint = cleanText(link.dataset?.bookingProviderId || link.dataset?.providerId || '');
    const slugHint = cleanLower(link.dataset?.bookingProviderSlug || link.dataset?.providerSlug || '');
    const nameHint = cleanLower(link.dataset?.bookingProviderName || link.dataset?.providerName || '');
    const href = cleanLower(link.href || link.getAttribute?.('href') || '');
    let providerParam = '';

    try {
      const url = new URL(link.href || link.getAttribute?.('href') || '', window.location.origin);
      providerParam = cleanLower(url.searchParams.get('provider') || url.searchParams.get('provider_id') || '');
    } catch {}

    const signal = cleanLower([
      slugHint,
      nameHint,
      providerParam,
      link.textContent || '',
      href,
    ].join(' '));

    return teamMembers().find((provider) => {
      const id = cleanText(provider.id);
      const label = cleanLower(provider.label);
      const slug = providerSlug(provider);

      return Boolean(
        id &&
          ((idHint && idHint === id) ||
            (providerParam && providerParam === cleanLower(id)) ||
            (slug && (slugHint === slug || providerParam === slug || signal.includes(slug))) ||
            (label && (nameHint === label || signal.includes(label)))),
      );
    }) || null;
  };

  const selectedVisitSegments = () => selectedLineItems().flatMap((item) => {
    const service = item.service;
    const segments = Array.isArray(service.segments) && service.segments.length
      ? service.segments
      : [{
          segmentId: `${service.slug}:1`,
          title: service.title,
          durationMinutes: service.durationMinutes,
          compatibleProviderIds: serviceProviderIds(service),
        }];

    return segments.map((segment, index) => {
      const segmentProviders = uniqueValues([
        ...(Array.isArray(segment.compatibleProviderIds) ? segment.compatibleProviderIds : []),
        ...(Array.isArray(segment.allowedTeamMemberIds) ? segment.allowedTeamMemberIds : []),
      ].map(cleanText));

      return {
        segmentId: `${item.id}:${index + 1}`,
        itemId: item.id,
        lineIndex: item.index,
        serviceSlug: service.slug,
        serviceTitle: service.title,
        segmentTitle: cleanText(segment.title || service.title),
        durationMinutes: Number(segment.durationMinutes || service.durationMinutes || 0),
        serviceVariationId: cleanText(segment.serviceVariationId || segment.squareCatalogObjectId || ''),
        compatibleProviderIds: segmentProviders.length ? segmentProviders : serviceProviderIds(service),
      };
    });
  });

  const providersForSegment = (segment = {}) => {
    const compatible = Array.isArray(segment.compatibleProviderIds) ? segment.compatibleProviderIds : [];
    const concrete = concreteTeamMembers();

    if (!compatible.length) return concrete;
    return concrete.filter((member) => compatible.includes(member.id));
  };

  const commonProvidersForSelectedVisit = () => {
    const segments = selectedVisitSegments();
    if (!segments.length) return concreteTeamMembers();

    return segments.slice(1).reduce((candidates, segment) => {
      const segmentProviderIds = providersForSegment(segment).map((provider) => provider.id);
      return candidates.filter((provider) => segmentProviderIds.includes(provider.id));
    }, providersForSegment(segments[0]));
  };

  const providersForLineItem = (item = {}) => {
    const segments = selectedVisitSegments().filter((segment) => segment.itemId === item.id);
    if (!segments.length) return concreteTeamMembers();

    return segments.slice(1).reduce((candidates, segment) => {
      const segmentProviderIds = providersForSegment(segment).map((provider) => provider.id);
      return candidates.filter((provider) => segmentProviderIds.includes(provider.id));
    }, providersForSegment(segments[0]));
  };

  const providerIdForLineItem = (item = {}) => {
    if (selectedSlotsByItem[item.id]?.teamMemberId) return selectedSlotsByItem[item.id].teamMemberId;
    if (Object.prototype.hasOwnProperty.call(selectedProvidersByItem, item.id)) {
      return selectedProvidersByItem[item.id] || 'any';
    }
    if (selectedProviderMode === 'same_provider_if_possible') return selectedProviderId || 'any';
    return 'any';
  };

  const selectedSlots = () => selectedLineItems()
    .map((item) => selectedSlotsByItem[item.id])
    .filter(Boolean);

  const currentBookingDateValue = () => bookingDate?.value || activeBookingDateValue || defaultBookingDateValue();

  const persistSlotSelectionForDate = (dateValue = currentBookingDateValue()) => {
    const key = cleanText(dateValue);
    if (!key) return;

    const entries = Object.entries(selectedSlotsByItem).filter(([, slot]) => slot?.startAt);
    if (entries.length) selectedSlotsByDate[key] = Object.fromEntries(entries);
    else delete selectedSlotsByDate[key];
  };

  const restoreSlotSelectionForDate = (dateValue = currentBookingDateValue()) => {
    const key = cleanText(dateValue);
    selectedSlotsByItem = { ...(selectedSlotsByDate[key] || {}) };
    selectedSlot = selectedSlots()[0] || null;
  };

  const removeSlotSelectionForItem = (itemId = '') => {
    const id = cleanText(itemId);
    if (!id) return;

    delete selectedSlotsByItem[id];
    Object.values(selectedSlotsByDate).forEach((slots) => {
      delete slots[id];
    });
    Object.keys(selectedSlotsByDate).forEach((key) => {
      if (!Object.keys(selectedSlotsByDate[key] || {}).length) delete selectedSlotsByDate[key];
    });
    selectedSlot = selectedSlots()[0] || null;
  };

  const slotProviderIds = (slot = {}) => {
    const fromSegments = Array.isArray(slot.appointmentSegments)
      ? slot.appointmentSegments.map((segment) => segment.teamMemberId || segment.team_member_id)
      : [];
    return uniqueValues([
      slot.teamMemberId,
      ...(Array.isArray(slot.teamMemberIds) ? slot.teamMemberIds : []),
      ...fromSegments,
    ].map(cleanText));
  };

  const slotDurationMinutes = (slot = {}, itemId = '') => {
    const lineDuration = Number(selectedLineItems().find((item) => item.id === itemId)?.service.durationMinutes || 0);
    if (Number.isFinite(lineDuration) && lineDuration > 0) return lineDuration;

    const directDuration = Number(slot.durationMinutes || slot.duration_minutes || 0);
    if (Number.isFinite(directDuration) && directDuration > 0) return directDuration;

    const segmentDuration = Array.isArray(slot.appointmentSegments)
      ? slot.appointmentSegments.reduce((total, segment) => total + Number(segment.durationMinutes || segment.duration_minutes || 0), 0)
      : 0;

    if (Number.isFinite(segmentDuration) && segmentDuration > 0) return segmentDuration;

    return 0;
  };

  const slotsOverlap = (firstSlot = {}, firstItemId = '', secondSlot = {}, secondItemId = '') => {
    const firstStart = new Date(firstSlot.startAt).getTime();
    const secondStart = new Date(secondSlot.startAt).getTime();

    if (!Number.isFinite(firstStart) || !Number.isFinite(secondStart)) return false;

    const firstDuration = slotDurationMinutes(firstSlot, firstItemId);
    const secondDuration = slotDurationMinutes(secondSlot, secondItemId);
    const firstEnd = firstStart + Math.max(1, firstDuration || 1) * 60000;
    const secondEnd = secondStart + Math.max(1, secondDuration || 1) * 60000;

    return firstStart < secondEnd && secondStart < firstEnd;
  };

  const slotRange = (slot = {}, itemId = '') => {
    const start = new Date(slot.startAt).getTime();
    if (!Number.isFinite(start)) return null;
    const duration = Math.max(1, slotDurationMinutes(slot, itemId) || 1) * 60000;
    return {
      start,
      end: start + duration,
      durationMinutes: Math.round(duration / 60000),
    };
  };

  const slotsMatch = (firstSlot = {}, secondSlot = {}) =>
    firstSlot?.startAt === secondSlot?.startAt &&
    JSON.stringify(firstSlot?.appointmentSegments || []) === JSON.stringify(secondSlot?.appointmentSegments || []);

  const sharedSlotProviderIds = (firstSlot = {}, secondSlot = {}) => {
    const providers = slotProviderIds(firstSlot);
    const selectedProviders = slotProviderIds(secondSlot);
    return selectedProviders.filter((providerId) => providers.includes(providerId));
  };

  const lineItemsCanOverlap = (firstItem = null, firstSlot = {}, secondItem = null, secondSlot = {}) => {
    if (!firstItem?.service || !secondItem?.service) return false;
    if (sharedSlotProviderIds(firstSlot, secondSlot).length) return false;

    const firstService = firstItem.service;
    const secondService = secondItem.service;
    return servicesCanOverlap(firstService, secondService);
  };

  const nailAddOnDependencyConflictDetail = (currentItem = null, currentSlot = {}, selectedItem = null, selectedSlot = {}) => {
    if (!currentItem?.service || !selectedItem?.service) return { conflict: false, reason: '' };
    const currentRange = slotRange(currentSlot, currentItem.id);
    const selectedRange = slotRange(selectedSlot, selectedItem.id);
    if (!currentRange || !selectedRange) return { conflict: false, reason: '' };

    const currentIsAddOn = serviceIsNailAddon(currentItem.service);
    const selectedIsAddOn = serviceIsNailAddon(selectedItem.service);
    const currentIsNailBase = serviceIsNail(currentItem.service) && !currentIsAddOn;
    const selectedIsNailBase = serviceIsNail(selectedItem.service) && !selectedIsAddOn;

    if (currentIsAddOn && selectedIsNailBase && currentRange.start < selectedRange.end) {
      return {
        conflict: true,
        reason: 'Nail add-ons must start after the nail service is finished.',
      };
    }

    if (currentIsNailBase && selectedIsAddOn && currentRange.end > selectedRange.start) {
      return {
        conflict: true,
        reason: 'The nail service must finish before its add-on starts.',
      };
    }

    return { conflict: false, reason: '' };
  };

  const slotConflictDetail = (itemId = '', slot = {}) => {
    if (!slot?.startAt) return { conflict: false, reason: '' };
    const currentItem = selectedLineItems().find((item) => item.id === itemId);
    if (!currentItem) return { conflict: false, reason: '' };

    for (const [selectedItemId, selectedSlot] of Object.entries(selectedSlotsByItem)) {
      if (selectedItemId === itemId || !selectedSlot?.startAt) continue;
      const selectedItem = selectedLineItems().find((item) => item.id === selectedItemId);
      if (!selectedItem) continue;

      const dependencyConflict = nailAddOnDependencyConflictDetail(currentItem, slot, selectedItem, selectedSlot);
      if (dependencyConflict.conflict) return dependencyConflict;

      if (!slotsOverlap(slot, itemId, selectedSlot, selectedItemId)) continue;

      const sharedProviders = sharedSlotProviderIds(slot, selectedSlot);
      if (sharedProviders.length) {
        return {
          conflict: true,
          reason: `${providerName(sharedProviders[0])} is already booked for ${serviceLineTitle(selectedItem.service)} at that time.`,
        };
      }

      if (!lineItemsCanOverlap(currentItem, slot, selectedItem, selectedSlot)) {
        const currentTitle = serviceLineTitle(currentItem.service);
        const selectedTitle = serviceLineTitle(selectedItem.service);
        if (serviceIsNailAddon(currentItem.service) || serviceIsNailAddon(selectedItem.service)) {
          return {
            conflict: true,
            reason: 'Nail add-ons must be booked after the nail service.',
          };
        }
        if (
          (serviceIsNail(currentItem.service) && serviceBlocksNailOverlap(selectedItem.service)) ||
          (serviceIsNail(selectedItem.service) && serviceBlocksNailOverlap(currentItem.service))
        ) {
          return {
            conflict: true,
            reason: `${currentTitle} cannot overlap ${selectedTitle}.`,
          };
        }
        return {
          conflict: true,
          reason: `${currentTitle} cannot overlap ${selectedTitle}.`,
        };
      }
    }

    return { conflict: false, reason: '' };
  };

  const slotConflictsWithOtherLines = (itemId = '', slot = {}) => slotConflictDetail(itemId, slot).conflict;

  const sameLineDurationHoldDetail = (itemId = '', slot = {}) => {
    const selected = selectedSlotsByItem[itemId];
    if (!selected?.startAt || !slot?.startAt || slotsMatch(selected, slot)) return { conflict: false, reason: '', label: '' };

    const selectedRange = slotRange(selected, itemId);
    const slotStart = new Date(slot.startAt).getTime();
    if (!selectedRange || !Number.isFinite(slotStart)) return { conflict: false, reason: '', label: '' };

    if (slotStart > selectedRange.start && slotStart < selectedRange.end) {
      const duration = formatDuration(selectedRange.durationMinutes);
      return {
        conflict: true,
        label: 'Held',
        reason: `This time is held by the selected${duration ? ` ${duration}` : ''} appointment.`,
      };
    }

    return { conflict: false, reason: '', label: '' };
  };

  const slotSelectionHasConflicts = () =>
    Object.entries(selectedSlotsByItem).some(([itemId, slot]) => slotConflictsWithOtherLines(itemId, slot));

  const allSlotsSelected = () => {
    const items = selectedLineItems();
    return Boolean(items.length && items.every((item) => selectedSlotsByItem[item.id]?.startAt) && !slotSelectionHasConflicts());
  };

  const pruneSelectedSlotsToAvailability = () => {
    selectedLineItems().forEach((item) => {
      const selected = selectedSlotsByItem[item.id];
      if (!selected?.startAt) return;
      const slots = bookingSlotsByItem[item.id] || [];
      const stillAvailable = slots.some((slot) =>
        slot.startAt === selected.startAt &&
        JSON.stringify(slot.appointmentSegments || []) === JSON.stringify(selected.appointmentSegments || []),
      );
      if (!stillAvailable) delete selectedSlotsByItem[item.id];
    });
    selectedSlot = selectedSlots()[0] || null;
    persistSlotSelectionForDate();
  };

  const internalServiceText = (value = '') =>
    /(?:live\s+square|square\s+production|private\s+booking\s+beta|mapped\s+for\s+the\s+private|test\s+candidate|write\s+test)/i.test(value);

  const publicPrice = (service = {}) => {
    return serviceDisplayPrice(service);
  };

  const serviceDescription = (service = {}) => {
    const description = cleanText(service.customerDescription || service.description || service.bestFor || service.includes || '');
    return internalServiceText(description) ? '' : description;
  };

  const serviceMeta = (service = {}) =>
      [
        service.category,
        formatDuration(service.durationMinutes),
        publicPrice(service),
        service.isAddOn ? 'Add-on' : '',
        service.requiresBaseService ? 'Requires base service' : '',
      ].filter(Boolean).join(' · ');

  const titleSplitPattern = /\s+-\s+/;

  const variationBaseTitle = (service = {}) => {
    const title = cleanText(service.title);
    if (!titleSplitPattern.test(title)) return '';
    return cleanText(title.split(titleSplitPattern)[0]);
  };

  const variationOptionTitle = (service = {}, baseTitle = '') => {
    const title = cleanText(service.title);
    const base = cleanText(baseTitle);
    if (base && title.startsWith(`${base} - `)) return cleanText(title.slice(base.length + 3));
    return title;
  };

  const serviceChoiceGroups = (services = []) => {
    const groups = new Map();
    const baseTitlesByCategory = services.reduce((map, service) => {
      const category = cleanText(service.category || 'Other');
      const baseTitle = variationBaseTitle(service);
      if (!baseTitle) return map;
      if (!map.has(category)) map.set(category, new Set());
      map.get(category).add(baseTitle);
      return map;
    }, new Map());

    services.forEach((service) => {
      const category = cleanText(service.category || 'Other');
      const title = cleanText(service.title);
      const baseTitle = variationBaseTitle(service) ||
        (baseTitlesByCategory.get(category)?.has(title) ? title : '');
      const key = baseTitle ? `${category}::${baseTitle}` : service.slug;
      if (!groups.has(key)) {
        groups.set(key, {
          key,
          category,
          label: baseTitle || service.title,
          services: [],
          isVariantGroup: Boolean(baseTitle),
        });
      }
      groups.get(key).services.push(service);
    });

    return [...groups.values()].map((group) => ({
      ...group,
      isVariantGroup: group.isVariantGroup && group.services.length > 1,
    }));
  };

  const durationRange = (services = []) => {
    const durations = services
      .map((service) => Number(service.durationMinutes || 0))
      .filter((duration) => Number.isFinite(duration) && duration > 0);

    if (!durations.length) return '';
    const min = Math.min(...durations);
    const max = Math.max(...durations);
    if (min === max) return formatDuration(min);
    return `${formatDuration(min)}-${formatDuration(max)}`;
  };

  const servicePriceRange = (services = []) => {
    const entries = services
      .map((service) => ({
        cents: servicePriceCents(service),
        currency: serviceCurrency(service),
        label: publicPrice(service),
      }))
      .filter((entry) => entry.cents !== null || entry.label);

    if (!entries.length) return services.length ? 'Price varies' : '';
    if (entries.length === 1) return entries[0].label || formatMoneyCents(entries[0].cents, entries[0].currency);

    const numericEntries = entries.filter((entry) => entry.cents !== null);
    if (!numericEntries.length) return 'Price varies';

    const currencies = [...new Set(numericEntries.map((entry) => entry.currency).filter(Boolean))];
    const currency = currencies.length === 1 ? currencies[0] : 'USD';
    const cents = numericEntries.map((entry) => entry.cents);
    const min = Math.min(...cents);
    const max = Math.max(...cents);

    if (numericEntries.length !== entries.length) return `From ${formatMoneyCents(min, currency)}`;
    if (min === max) return formatMoneyCents(min, currency);
    return `${formatMoneyCents(min, currency)}-${formatMoneyCents(max, currency)}`;
  };

  const optionPreview = (group = {}) => group.services
    .slice(0, 4)
    .map((service) => variationOptionTitle(service, group.label))
    .join(', ');

  const findServiceChoiceGroup = (key = '', services = visibleServices()) =>
    serviceChoiceGroups(services).find((group) => group.key === key) || null;

  const serviceChoiceGroupForService = (service = null) => {
    if (!service) return null;
    const category = cleanText(service.category || 'Other');
    const services = catalogServices().filter((candidate) => cleanText(candidate.category || 'Other') === category);
    return serviceChoiceGroups(services).find((group) => group.services.some((candidate) => candidate.slug === service.slug)) || null;
  };

  const serviceLineTitle = (service = null) => {
    if (!service) return '';
    const group = serviceChoiceGroupForService(service);
    if (!group?.isVariantGroup) return service.title;
    return `${group.label} - ${variationOptionTitle(service, group.label)}`;
  };

  const serviceLineMeta = (service = null) => {
    if (!service) return '';
    const group = serviceChoiceGroupForService(service);
    const option = group?.isVariantGroup ? variationOptionTitle(service, group.label) : '';
    return [
      service.category,
      option && group?.isVariantGroup ? option : '',
      formatDuration(service.durationMinutes),
      publicPrice(service),
    ].filter(Boolean).join(' · ');
  };

  const multipleServiceVisit = () => selectedLineItems().length > 1;

  const syncProviderFilterAssignments = ({ resetExisting = false } = {}) => {
    const providerIds = effectiveServiceProviderFilterIds();
    const items = selectedLineItems();

    if (!providerIds.length) {
      if (!items.length) {
        selectedProviderMode = 'first_available';
        selectedProviderId = 'any';
        selectedProvidersByItem = {};
      }
      return;
    }

    if (!items.length) {
      selectedProviderMode = providerIds.length === 1 ? 'same_provider_if_possible' : 'provider_per_service';
      selectedProviderId = providerIds.length === 1 ? providerIds[0] : 'any';
      selectedProvidersByItem = {};
      return;
    }

    if (providerIds.length === 1 && items.every((item) => serviceAllowsProvider(item.service, providerIds[0]))) {
      selectedProviderMode = 'same_provider_if_possible';
      selectedProviderId = providerIds[0];
      selectedProvidersByItem = {};
      return;
    }

    selectedProviderMode = 'provider_per_service';
    selectedProviderId = 'any';

    const nextProvidersByItem = {};
    const assignmentCounts = Object.fromEntries(providerIds.map((id) => [id, 0]));

    items.forEach((item) => {
      const compatibleIds = providerIds.filter((id) => serviceAllowsProvider(item.service, id));
      const existingProviderId = resetExisting ? '' : selectedProvidersByItem[item.id];

      if (existingProviderId && compatibleIds.includes(existingProviderId)) {
        nextProvidersByItem[item.id] = existingProviderId;
        assignmentCounts[existingProviderId] = (assignmentCounts[existingProviderId] || 0) + 1;
        return;
      }

      if (!compatibleIds.length) {
        nextProvidersByItem[item.id] = 'any';
        return;
      }

      const providerId = compatibleIds
        .slice()
        .sort((first, second) => (assignmentCounts[first] || 0) - (assignmentCounts[second] || 0))[0];
      nextProvidersByItem[item.id] = providerId;
      assignmentCounts[providerId] = (assignmentCounts[providerId] || 0) + 1;
    });

    selectedProvidersByItem = nextProvidersByItem;
  };

  const normalizeProviderModeForVisit = () => {
    const providerFilterIds = effectiveServiceProviderFilterIds();
    if (
      multipleServiceVisit() &&
      providerFilterIds.length === 1 &&
      commonProvidersForSelectedVisit().some((provider) => provider.id === providerFilterIds[0])
    ) {
      selectedProviderMode = 'same_provider_if_possible';
      selectedProviderId = providerFilterIds[0];
      return;
    }

    if (multipleServiceVisit() && selectedProviderMode !== 'provider_per_service') {
      selectedProviderMode = 'provider_per_service';
      selectedProviderId = 'any';
    }
  };

  const providerModeLabel = () => {
    normalizeProviderModeForVisit();

    if (selectedProviderMode === 'same_provider_if_possible') {
      return selectedProviderId && selectedProviderId !== 'any'
        ? providerName(selectedProviderId)
        : 'One staff member if available';
    }
    if (selectedProviderMode === 'provider_per_service') {
      const assigned = selectedLineItems().map((item) => {
        const providerId = Object.prototype.hasOwnProperty.call(selectedProvidersByItem, item.id)
          ? selectedProvidersByItem[item.id]
          : '';
        return providerId ? `${serviceLineTitle(item.service)}: ${providerName(providerId)}` : '';
      }).filter(Boolean);
      return assigned.length ? assigned.join('\n') : 'Choose staff for each service';
    }
    return 'Any staff';
  };

  const providerSelectionReady = () => {
    normalizeProviderModeForVisit();

    if (selectedProviderMode === 'first_available') return true;
    if (selectedProviderMode === 'same_provider_if_possible') return Boolean(selectedProviderId && selectedProviderId !== 'any');
    if (selectedProviderMode !== 'provider_per_service') return false;
    const items = selectedLineItems();
    return Boolean(
      items.length &&
      items.every((item) => Object.prototype.hasOwnProperty.call(selectedProvidersByItem, item.id)),
    );
  };

  const categoryFromLink = (link) => {
    const signal = cleanLower([
      link?.dataset?.bookingCategoryHint || '',
      link?.textContent || '',
      link?.href || '',
    ].join(' '));
    if (signal.includes('hydrafacial') || signal.includes('keravive')) return 'Hydrafacial';
    if (signal.includes('facial') || signal.includes('skin')) return 'Facials';
    if (signal.includes('lash')) return 'Lashes';
    if (signal.includes('brow')) return 'Brows';
    if (signal.includes('wax')) return 'Waxing';
    if (signal.includes('body')) return 'Body';
    if (signal.includes('nail') || signal.includes('mani') || signal.includes('pedi')) return 'Nails';
    return '';
  };

  const serviceFromLink = (link) => {
    const href = cleanLower(link?.href || link?.getAttribute?.('href') || '');
    const articleText = cleanLower(link?.closest?.('article')?.textContent || '');
    const titleHint = cleanLower(link?.dataset?.bookingServiceTitle || '');
    const slugHint = cleanLower(link?.dataset?.bookingServiceSlug || '');
    const signal = cleanLower([
      titleHint,
      slugHint,
      link?.textContent || '',
      href,
      articleText,
    ].join(' '));

    const isSpecificSquareServiceUrl = (url = '') => /\/services\/[^/?#]+/.test(cleanLower(url));
    const serviceUrlMatches = (url = '') => {
      const value = cleanLower(url);
      return Boolean(
        value &&
          isSpecificSquareServiceUrl(value) &&
          (href === value || href.startsWith(`${value}?`) || href.startsWith(`${value}#`)),
      );
    };

    const candidates = catalogServices().map((service) => {
      const title = cleanLower(service.title);
      const slug = cleanLower(service.slug).replace(/-/g, ' ');
      const slugDashed = cleanLower(service.slug);
      const serviceUrl = cleanLower(service.fallbackBookingUrl || service.bookingUrl || service.booking_url || '');
      const variationIds = (Array.isArray(service.segments) ? service.segments : [])
        .map((segment) => cleanLower(segment.serviceVariationId || segment.service_variation_id || ''))
        .filter(Boolean);
      let score = 0;

      if (serviceUrlMatches(serviceUrl)) score = Math.max(score, 1000);
      if (titleHint && titleHint === title) score = Math.max(score, 950);
      if (slugHint && (slugHint === slugDashed || slugHint === slug)) score = Math.max(score, 900);
      if (titleHint && title.includes(titleHint)) score = Math.max(score, 850);
      if (titleHint && titleHint.includes(title)) score = Math.max(score, 500);
      if (variationIds.some((variationId) => href.includes(variationId))) score = Math.max(score, 760);
      if (title && signal.includes(title)) score = Math.max(score, 700);
      if (slug && signal.includes(slug)) score = Math.max(score, 620);
      if (slugDashed && signal.includes(slugDashed)) score = Math.max(score, 620);

      return { service, score, titleLength: title.length };
    }).filter((candidate) => candidate.score > 0);

    candidates.sort((a, b) => b.score - a.score || b.titleLength - a.titleLength);
    return candidates[0]?.service || null;
  };

  const serviceGroupFromLink = (link) => {
    if (!link) return null;
    const href = cleanLower(link.href || link.getAttribute?.('href') || '');
    const titleHint = cleanLower(link.dataset?.bookingServiceTitle || '');
    const slugHint = cleanLower(link.dataset?.bookingServiceSlug || '');
    const articleText = cleanLower(link.closest?.('article')?.textContent || '');
    const signal = cleanLower([
      titleHint,
      slugHint,
      link.textContent || '',
      href,
      articleText,
    ].join(' '));
    const groups = serviceChoiceGroups(catalogServices());
    const isSpecificSquareServiceUrl = (url = '') => /\/services\/[^/?#]+/.test(cleanLower(url));
    const hrefMatchesServiceUrl = (url = '') => {
      const value = cleanLower(url);
      return Boolean(
        value &&
          isSpecificSquareServiceUrl(value) &&
          (href === value || href.startsWith(`${value}?`) || href.startsWith(`${value}#`)),
      );
    };

    return groups.find((group) => {
      const label = cleanLower(group.label);
      const key = cleanLower(group.key);
      const category = cleanLower(group.category || '');
      const groupUrls = (group.services || [])
        .map((service) => cleanLower(service.fallbackBookingUrl || service.bookingUrl || service.booking_url || ''))
        .filter(Boolean);
      const groupTokens = (group.services || []).flatMap((service) => {
        const title = cleanLower(service.title);
        const slug = cleanLower(service.slug || '');
        const slugWords = slug.replace(/-/g, ' ');
        const variationIds = (Array.isArray(service.segments) ? service.segments : [])
          .map((segment) => cleanLower(segment.serviceVariationId || segment.service_variation_id || ''))
          .filter(Boolean);

        return [title, slug, slugWords, ...variationIds].filter(Boolean);
      });

      return Boolean(
        label &&
          ((titleHint && (titleHint === label || titleHint.includes(label) || label.includes(titleHint))) ||
            signal.includes(label) ||
            signal.includes(key) ||
            (category && signal.includes(category) && articleText.includes(label)) ||
            groupUrls.some(hrefMatchesServiceUrl) ||
            groupTokens.some((token) => token && href.includes(token))),
      );
    }) || null;
  };

  const hrefLooksLikeBooking = (href = '') => {
    const value = cleanLower(href);
    if (!value) return false;
    if (value.includes('book.squareup.com/appointments')) return true;
    if (value.includes('appointments.allsixsalon.com') && !value.includes('/s/shop')) return true;
    if (value.includes('booking=1') || value.includes('booking=true') || value.includes('booking=open')) return true;
    if (value.includes('book=1') || value.includes('open=booking')) return true;
    if (value.endsWith('#booking') || value.endsWith('#book')) return true;
    return false;
  };

  const linkShouldOpenBooking = (link) => {
    if (!link || !publicDrawerEnabled) return false;
    if (link.hasAttribute('data-booking-open')) return true;
    return hrefLooksLikeBooking(link.href || link.getAttribute('href') || '');
  };

  const urlRequestsBooking = () => {
    const params = new URLSearchParams(window.location.search || '');
    const bookingValue = cleanLower(params.get('booking') || params.get('book') || params.get('open') || '');
    const hashValue = cleanLower((window.location.hash || '').replace(/^#/, ''));

    return Boolean(
      params.has('booking') ||
        params.has('book') ||
        bookingValue === 'booking' ||
        bookingValue === 'true' ||
        bookingValue === 'open' ||
        bookingValue === '1' ||
        hashValue === 'booking' ||
        hashValue === 'book',
    );
  };

  const apiJson = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'omit',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });
    const payload = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw squareDisplayError(
        {
          ...payload,
          status: response.status,
          squareStatus: payload.squareStatus || response.status,
        },
        `Request failed: ${response.status}`,
      );
    }

    return payload;
  };

  const ensureBookingConfig = () => {
    if (bookingConfigPromise) return bookingConfigPromise;
    bookingConfigPromise = apiJson(configApiUrl).then((payload) => {
      bookingConfig = payload;
      renderPaymentVisibility();
      return payload;
    }).catch((error) => {
      bookingConfig = { payments: { enabled: false }, paymentError: error.message };
      renderPaymentVisibility();
      return bookingConfig;
    });
    return bookingConfigPromise;
  };

  const paymentsReady = () => {
    const payments = bookingConfig?.payments || {};
    return Boolean(payments.enabled && payments.applicationId && payments.locationId);
  };

  const paymentConfigLoaded = () => Boolean(bookingConfig);
  const cardCaptureRequired = () => paymentsReady();

  const renderPaymentVisibility = () => {
    const visible = cardCaptureRequired();
    if (bookingCardPolicy) bookingCardPolicy.hidden = !visible;
    if (bookingCardShell) bookingCardShell.hidden = !visible;
    if (!visible) {
      squarePayments = null;
      squareCard = null;
      squareCardReady = false;
      squareCardPromise = null;
      squareToken = '';
      squareVerificationToken = '';
      if (bookingPaymentStatus) {
        bookingPaymentStatus.textContent = '';
        delete bookingPaymentStatus.dataset.paymentState;
        delete bookingPaymentStatus.dataset.squareErrorCode;
        delete bookingPaymentStatus.dataset.squareErrorStatus;
      }
    }
  };

  const loadSquareSdk = async () => {
    if (window.Square) return;
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const production = (bookingConfig?.environment || '').toLowerCase() === 'production';
      script.src = production ? 'https://web.squarecdn.com/v1/square.js' : 'https://sandbox.web.squarecdn.com/v1/square.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error('Square card form could not load.'));
      document.head.appendChild(script);
    });
  };

  const initializeSquareCard = () => {
    if (squareCardPromise) return squareCardPromise;
    squareCardPromise = (async () => {
      await ensureBookingConfig();

      if (!paymentsReady()) {
        throw new Error('Square card capture is not configured yet.');
      }

      await loadSquareSdk();

      if (!window.Square) throw new Error('Square card form could not load.');

      squarePayments = window.Square.payments(
        bookingConfig.payments.applicationId,
        bookingConfig.payments.locationId,
      );
      squareCard = await squarePayments.card();
      [
        'postalCodeChanged',
        'errorClassAdded',
        'errorClassRemoved',
        'cardBrandChanged',
        'focusClassAdded',
        'focusClassRemoved',
        'submit',
      ].forEach((eventName) => {
        try {
          squareCard.addEventListener(eventName, (event) => updateSquareCardInputState(eventName, event));
        } catch {
          squareCardInputState = squareCardInputState || {};
        }
      });
      await squareCard.attach('#AllSixSquareCardContainer');
      squareCardReady = true;
      setPaymentStatus('Card form ready.');
      setFooterState();
      return squareCard;
    })().catch((error) => {
      squareCard = null;
      squareCardReady = false;
      squareCardPromise = null;
      const displayError = squareDisplayError(error, 'Square card form could not load.');
      setPaymentStatus(`${displayError.message} Please call All Six if you need help reserving.`, displayError);
      setFooterState();
      throw displayError;
    });
    return squareCardPromise;
  };

  const invalidateCardToken = () => {
    squareToken = '';
    squareVerificationToken = '';
    if (bookingCreated) return;
    if (bookingStep >= 3 && squareCardReady) setPaymentStatus('Card form ready.');
  };

  const clientFullName = () => cleanText([bookingFirstName?.value, bookingLastName?.value].filter(Boolean).join(' '));

  const syncCardholderName = () => {
    if (!bookingCardholderName || cardholderNameTouched) return;
    const name = clientFullName();
    if (name && cleanText(bookingCardholderName.value) !== name) bookingCardholderName.value = name;
  };

  const squareBillingContact = () => {
    syncCardholderName();
    const cardholderName = cleanText(bookingCardholderName?.value) || clientFullName();
    const contact = {
      givenName: cleanText(bookingFirstName?.value) || cardholderName,
      familyName: cleanText(bookingLastName?.value),
      email: cleanText(bookingEmail?.value),
      phone: cleanText(bookingPhone?.value),
      countryCode: 'US',
      postalCode: cleanText(squareCardInputState.postalCodeValue),
    };

    return Object.fromEntries(Object.entries(contact).filter(([, value]) => cleanText(value)));
  };

  const squareStoreVerificationDetails = () => ({
    billingContact: squareBillingContact(),
    intent: 'STORE',
    customerInitiated: true,
    sellerKeyedIn: false,
  });

  const tokenizeSquareCard = async () => {
    if (squareToken) return squareToken;
    const card = await initializeSquareCard();
    let tokenResult = null;

    try {
      tokenResult = await card.tokenize(squareStoreVerificationDetails());
    } catch (error) {
      throw squareDisplayError(squareThrownError(error, 'Card.tokenize()'), 'Square card tokenization failed.');
    }

    if (tokenResult.status !== 'OK') {
      throw squareDisplayError(
        tokenResult,
        'Square could not secure this card. Check the card details and try again.',
      );
    }

    squareToken = tokenResult.token;
    setPaymentStatus('Card secured for this reservation.');
    return squareToken;
  };

  const verifySquareBuyer = async (token = '') => {
    if (squareVerificationToken) return squareVerificationToken;
    const paymentToken = cleanText(token) || await tokenizeSquareCard();

    await initializeSquareCard();

    if (!squarePayments || typeof squarePayments.verifyBuyer !== 'function') {
      throw squareDisplayError(
        { code: 'VERIFY_BUYER_UNAVAILABLE', squareSource: 'Payments.verifyBuyer()' },
        'Square card verification is not available. Please try again or call All Six.',
      );
    }

    setPaymentStatus('Verifying card with Square...');

    let verificationResult = null;
    try {
      verificationResult = await squarePayments.verifyBuyer(paymentToken, squareStoreVerificationDetails());
    } catch (error) {
      throw squareDisplayError(squareThrownError(error, 'Payments.verifyBuyer()'), 'Square could not verify this card.');
    }

    const verificationToken = cleanText(
      verificationResult?.token ||
        verificationResult?.verificationToken ||
        verificationResult?.buyerVerificationToken,
    );

    if (!verificationToken) {
      throw squareDisplayError(
        verificationResult || { code: 'VERIFY_BUYER_EMPTY' },
        'Square could not verify this card. Please use another card.',
      );
    }

    squareVerificationToken = verificationToken;
    setPaymentStatus('Card verified with Square.');
    return squareVerificationToken;
  };

  const categoryCounts = () => {
    const counts = new Map();
    catalogServices().forEach((service) => {
      const category = cleanText(service.category || 'Other');
      counts.set(category, (counts.get(category) || 0) + 1);
    });
    return counts;
  };

  const catalogCategories = () => {
    const counts = categoryCounts();
    const fromPayload = Array.isArray(bookingCatalog.categories) ? bookingCatalog.categories : [];
    const categories = fromPayload
      .map((category) => cleanText(category.title || category.name || category))
      .filter(Boolean)
      .filter((category, index, values) => values.indexOf(category) === index);

    catalogServices().forEach((service) => {
      const category = cleanText(service.category || 'Other');
      if (category && !categories.includes(category)) categories.push(category);
    });

    return categories.map((category) => ({
      title: category,
      count: counts.get(category) || 0,
    }));
  };

  const normalizeCatalog = (payload = {}) => {
    const services = Array.isArray(payload.services) ? payload.services.filter(serviceIsPubliclyBookable) : [];

    return {
      services,
      categories: Array.isArray(payload.categories) ? payload.categories : [],
      fallbackBookingUrl: payload.fallbackBookingUrl || fallbackBookingUrl,
    };
  };

  const normalizeTeam = (payload = {}) => ({
    state: payload.state || 'fallback',
    capabilities: payload.capabilities || {},
    team: Array.isArray(payload.team)
      ? payload.team.map((member) => ({
          id: cleanText(member.id || member.teamMemberId),
          label: publicStaffName(member),
          bookable: member.bookable !== false,
        })).filter((member) => member.id)
      : [],
  });

  const fetchCatalog = async (url) => {
    if (!url) throw new Error('Missing service catalog URL.');
    const response = await fetch(url, {
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error(`Service catalog request failed: ${response.status}`);

    return response.json();
  };

  const fetchTeam = async () => {
    if (!teamApiUrl) throw new Error('Missing Square team URL.');
    const response = await fetch(teamApiUrl, {
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error(`Team request failed: ${response.status}`);

    return response.json();
  };

  const visibleServices = () => {
    const search = cleanLower(bookingServiceSearch?.value || '');
    const categories = selectedCategoryList();
    const providerFilterIds = serviceEntryMode === 'providers' ? effectiveServiceProviderFilterIds() : [];

    return catalogServices().filter((service) => {
      const category = cleanText(service.category || 'Other');
      const haystack = cleanLower([
        service.title,
        service.category,
        service.description,
        service.bestFor,
        service.includes,
        service.startingPrice,
      ].join(' '));
      const matchesCategory = !categories.length || categories.includes(category);
      const matchesSearch = !search || haystack.includes(search);
      const matchesProvider = !providerFilterIds.length || providerFilterIds.some((id) => serviceAllowsProvider(service, id));

      return matchesCategory && matchesSearch && matchesProvider;
    });
  };

  const selectedSquareSegments = () =>
    selectedServices().flatMap((service) =>
      Array.isArray(service.segments) && service.segments.length
        ? service.segments.map((segment) => ({
            title: segment.title || service.title,
            durationMinutes: segment.durationMinutes,
          }))
        : [{ title: service.title, durationMinutes: service.durationMinutes }],
    ).filter((segment) => segment?.title);

  const bookingPayloadBase = () => {
    const firstItem = selectedLineItems()[0] || null;
    const firstSlot = firstItem ? selectedSlotsByItem[firstItem.id] : null;
    const providerId = firstSlot?.teamMemberId ||
      (selectedProviderMode === 'same_provider_if_possible' ? selectedProviderId : 'any');
    const bookingItems = selectedLineItems().map((item) => {
      const slot = selectedSlotsByItem[item.id] || {};
      const lineProviderId = slot.teamMemberId || providerIdForLineItem(item);

      return {
        lineId: item.id,
        lineNumber: item.index + 1,
        serviceSlug: item.service.slug,
        serviceTitle: serviceLineTitle(item.service),
        providerId: lineProviderId || 'any',
        teamMemberId: lineProviderId || 'any',
        startAt: slot.startAt || '',
        appointmentSegments: Array.isArray(slot.appointmentSegments) ? slot.appointmentSegments : [],
      };
    });

    return {
      serviceSlug: firstItem?.service.slug || '',
      serviceSlugs: selectedServiceSlugs(),
      providerMode: selectedProviderMode,
      providerId: providerId || 'any',
      teamMemberId: providerId || 'any',
      providersBySegment: selectedProviderMode === 'provider_per_service' ? selectedProvidersBySegment : {},
      providersByItem: selectedProviderMode === 'provider_per_service' ? selectedProvidersByItem : {},
      bookingItems,
      serviceLines: bookingItems,
    };
  };

  const cancellationPolicyMessage = () => {
    return 'We ask that you please reschedule or cancel at least 1 day before the beginning of your appointment or you may be charged a cancellation fee. Late cancellations & no-show: 50% of the service.';
  };

  const renderBookingSummary = () => {
    const targets = [bookingSummary, bookingReview].filter(Boolean);
    const items = selectedLineItems();
    const services = items.map((item) => item.service);
    const duration = services.reduce((total, service) => total + Number(service.durationMinutes || 0), 0);
    const contact = [cleanText(bookingPhone?.value), cleanText(bookingEmail?.value)].filter(Boolean).join('\n');
    const serviceTitles = items.map((item) => `${item.index + 1}. ${serviceLineTitle(item.service)}`).filter(Boolean);
    const providerTitles = items.map((item) => `${item.index + 1}. ${providerName(providerIdForLineItem(item))}`).filter(Boolean);
    const timeTitles = items.map((item) => {
      const slot = selectedSlotsByItem[item.id];
      return `${item.index + 1}. ${slot?.startAt ? formatDateTime(slot.startAt) : 'Choose an opening'}`;
    });
    const pricing = visitPricingSummary();
    const money = (cents) => formatMoneyCents(cents, pricing.currency);
    const showTotals = pricing.items.length > 0 && pricing.allFixed;
    const showLinePrices = showTotals || pricing.items.some((entry) => entry.cents !== null);
    const variablePriceNotice = pricing.hasVariablePricing
      ? [
          '<p class="as-booking-drawer__price-note">',
          'Price varies for this selection. Final pricing is confirmed at your appointment.',
          '</p>',
        ].join('')
      : '';
    const rows = items.length
      ? [
          ['Services', serviceTitles.join('\n')],
          ['Duration', formatDuration(duration) || 'Varies by service'],
          ['Provider', providerTitles.join('\n') || providerModeLabel()],
          ['Time', timeTitles.join('\n')],
          ['Client', [cleanText(bookingFirstName?.value), cleanText(bookingLastName?.value)].filter(Boolean).join(' ') || 'Add name'],
          ['Contact', contact || 'Phone or email required'],
          ['Card', squareToken ? 'Secured with Square' : 'Required before confirming'],
        ]
      : [
          ['Services', 'Add a service to your visit'],
        ];
    const html = [
      '<div class="as-booking-drawer__summary-shell">',
      '<dl>',
      ...rows.map((row) => `<div><dt>${escapeHtml(row[0])}</dt><dd>${escapeHtml(row[1])}</dd></div>`),
      '</dl>',
      items.length
        ? [
            showLinePrices
              ? [
                  '<div class="as-booking-drawer__price-lines" aria-label="Appointment pricing">',
                  ...pricing.items.map(({ item, label, cents }) => (
                    '<div>' +
                    `<span>${escapeHtml(`${item.index + 1}. ${serviceLineTitle(item.service)}`)}</span>` +
                    `<strong>${escapeHtml(cents === null ? 'Confirmed at appointment' : label)}</strong>` +
                    '</div>'
                  )),
                  '</div>',
                ].join('')
              : '',
            variablePriceNotice,
            showTotals
              ? [
                  '<div class="as-booking-drawer__totals" aria-label="Appointment totals">',
                  `<div><span>Subtotal</span><strong>${escapeHtml(money(pricing.subtotalCents))}</strong></div>`,
                  `<div><span>Taxes</span><strong>${escapeHtml(money(pricing.taxCents))}</strong></div>`,
                  `<div><span>Total</span><strong>${escapeHtml(money(pricing.totalCents))}</strong></div>`,
                  `<div><span>Due today</span><strong>${escapeHtml(money(pricing.dueTodayCents))}</strong></div>`,
                  `<div><span>Due at appointment</span><strong>${escapeHtml(money(pricing.dueAtAppointmentCents))}</strong></div>`,
                  '</div>',
                ].join('')
              : '',
          ].join('')
        : '',
      '</div>',
    ].join('');

    if (bookingSummary) bookingSummary.innerHTML = html;
    if (bookingReview) {
      const policyHtml = items.length
        ? [
            '<aside class="as-booking-drawer__policy as-booking-drawer__review-policy" aria-label="Cancellation policy">',
            '<strong>Cancellation policy</strong>',
            `<span>${escapeHtml(cancellationPolicyMessage())}</span>`,
            '</aside>',
          ].join('')
        : '';
      bookingReview.innerHTML = html + policyHtml;
    }
  };

  const renderCategories = () => {
    if (!bookingCategoryList) return;
    const categories = catalogCategories();
    const buttons = categories.map((category) => (
        `<button type="button" data-booking-category="${escapeHtml(category.title)}" aria-pressed="${String(selectedCategories.has(category.title))}">` +
        `${escapeHtml(category.title)}` +
        '</button>'
      ));

    bookingCategoryList.innerHTML = buttons.join('');
  };

  const renderServiceTypes = () => {
    if (!bookingServiceTypeList) return;
    const categories = catalogCategories();

    if (!categories.length) {
      bookingServiceTypeList.innerHTML = '';
      if (bookingTypeStatus) {
        bookingTypeStatus.hidden = false;
        bookingTypeStatus.textContent = bookingCatalogSource === 'loading'
          ? 'Loading service types...'
          : 'Service types are not available right now.';
      }
      return;
    }

    bookingServiceTypeList.innerHTML = categories.map((category) => (
        `<button type="button" data-booking-service-type="${escapeHtml(category.title)}" aria-pressed="${String(selectedCategories.has(category.title))}">` +
        `<span>${escapeHtml(category.title)}</span>` +
        '<small>Choose this service type.</small>' +
        '</button>'
      )).join('');

    if (bookingTypeStatus) {
      bookingTypeStatus.hidden = false;
      bookingTypeStatus.textContent = selectedCategories.size
        ? 'Choose another type to widen the service list, or continue with your selected filters.'
        : 'No filter selected. Continue to view all services, or choose a type to narrow the list.';
    }
  };

  const serviceCardHtml = (service) => {
    const selectedCount = selectedLineCountForService(service.slug);
    const pressed = selectedCount > 0;
    const description = serviceDescription(service);
    const price = serviceDisplayPrice(service);

    return (
      `<div class="as-booking-drawer__service-choice" data-booking-service-choice="${escapeHtml(service.slug)}">` +
      `<button type="button" data-booking-service-slug="${escapeHtml(service.slug)}" aria-pressed="${String(pressed)}">` +
      `<span>${escapeHtml(service.title)}</span>` +
      `<small>${escapeHtml(serviceMeta(service))}</small>` +
      (price ? `<strong class="as-booking-drawer__service-price">${escapeHtml(price)}</strong>` : '') +
      (description ? `<em>${escapeHtml(description)}</em>` : '') +
      '</button>' +
      '<div class="as-booking-drawer__quantity" aria-label="Service quantity">' +
      `<button type="button" data-booking-service-quantity="decrease" data-booking-service-slug="${escapeHtml(service.slug)}" aria-label="${escapeHtml(`Remove one ${service.title}`)}" ${selectedCount ? '' : 'disabled'}>−</button>` +
      `<span aria-live="polite">${escapeHtml(String(selectedCount))}</span>` +
      `<button type="button" data-booking-service-quantity="increase" data-booking-service-slug="${escapeHtml(service.slug)}" aria-label="${escapeHtml(`Add one ${service.title}`)}">+</button>` +
      '</div>' +
      '</div>'
    );
  };

  const serviceGroupCardHtml = (group) => {
    if (!group.isVariantGroup) return serviceCardHtml(group.services[0]);

    const selectedCount = group.services.reduce((total, service) => total + selectedLineCountForService(service.slug), 0);
    const selected = selectedCount > 0;
    const duration = durationRange(group.services);
    const price = servicePriceRange(group.services);
    const countLabel = group.services.length === 1 ? '1 option' : `${group.services.length} options`;
    const selectedLabel = selectedCount ? `${selectedCount} selected` : countLabel;
    const meta = [group.category, selectedLabel, duration].filter(Boolean).join(' · ');
    const preview = optionPreview(group);

    return (
      `<button type="button" data-booking-service-group-key="${escapeHtml(group.key)}" aria-pressed="${String(selected)}">` +
      `<span>${escapeHtml(group.label)}</span>` +
      `<small>${escapeHtml(meta)}</small>` +
      (price ? `<strong class="as-booking-drawer__service-price">${escapeHtml(price)}</strong>` : '') +
      (preview ? `<em>${escapeHtml(preview)}</em>` : '') +
      '</button>'
    );
  };

  const renderServiceList = () => {
    if (!bookingServiceList) return;
    const providerModeNeedsSelection = serviceEntryMode === 'providers' && !effectiveServiceProviderFilterIds().length;

    if (bookingServiceTools) bookingServiceTools.hidden = providerModeNeedsSelection;

    if (providerModeNeedsSelection) {
      bookingServiceList.innerHTML = '';
      if (bookingServiceStatus) {
        bookingServiceStatus.hidden = false;
        bookingServiceStatus.textContent = 'Choose one or more providers to see compatible services.';
      }
      return;
    }

    const services = visibleServices();
    const total = catalogServices().length;
    const search = cleanLower(bookingServiceSearch?.value || '');
    const hasCategoryFilters = Boolean(selectedCategories.size);

    if (bookingServiceStatus) {
      bookingServiceStatus.hidden = Boolean(total && !search);
      bookingServiceStatus.textContent = total
        ? !hasCategoryFilters
          ? 'Showing all service groups.'
          : search && hasCategoryFilters
          ? 'Showing selected service groups that match your search.'
          : search
          ? 'Showing services that match your search.'
          : hasCategoryFilters
            ? 'Showing selected service groups.'
          : ''
        : 'Loading services...';
    }

    if (!services.length) {
      bookingServiceList.innerHTML = `<p class="as-booking-drawer__empty">${search || hasCategoryFilters ? 'No services match these filters.' : 'No services are available right now.'}</p>`;
      return;
    }

    const servicesByCategory = services.reduce((groups, service) => {
      const category = cleanText(service.category || 'Other');
      if (!groups.has(category)) groups.set(category, []);
      groups.get(category).push(service);
      return groups;
    }, new Map());
    const categories = catalogCategories().map((category) => category.title);
    const orderedCategories = [
      ...categories.filter((category) => servicesByCategory.has(category)),
      ...[...servicesByCategory.keys()].filter((category) => !categories.includes(category)),
    ];

    bookingServiceList.innerHTML = orderedCategories.map((category) => {
      const categoryServices = servicesByCategory.get(category) || [];
      return (
        `<section class="as-booking-drawer__service-group" data-booking-service-group="${escapeHtml(category)}">` +
        `<h4>${escapeHtml(category)}</h4>` +
        '<div class="as-booking-drawer__service-group-list">' +
        serviceChoiceGroups(categoryServices).map(serviceGroupCardHtml).join('') +
        '</div>' +
        '</section>'
      );
    }).join('');
  };

  const renderSelectedService = () => {
    if (!bookingSelectedService || !bookingSegmentList || !bookingAddOnList) return;

    const items = selectedLineItems();

    if (!items.length) {
      bookingSelectedService.hidden = true;
      bookingSegmentList.hidden = true;
      bookingAddOnList.hidden = false;
      bookingSelectedService.innerHTML = '<p class="as-booking-drawer__empty">Add a service first.</p>';
      bookingSegmentList.innerHTML = '';
      bookingAddOnList.innerHTML = [
        '<h4>Your appointment</h4>',
        '<p class="as-booking-drawer__empty">Choose any service from the list. Add the same service again when booking for more than one person.</p>',
      ].join('');
      return;
    }

    bookingSelectedService.hidden = false;
    bookingAddOnList.hidden = false;

    bookingSelectedService.innerHTML = [
      '<div class="as-booking-drawer__visit-cart">',
      '<div class="as-booking-drawer__visit-cart-head">',
      '<small>Your visit</small>',
      `<strong>${escapeHtml(items.length === 1 ? '1 service' : `${items.length} services`)}</strong>`,
      '</div>',
      '<div class="as-booking-drawer__visit-lines">',
      ...items.map((item) => (
        `<div class="as-booking-drawer__visit-line" data-booking-visit-line="${escapeHtml(item.id)}">` +
        '<div>' +
        `<small>Service ${item.index + 1}</small>` +
        `<strong>${escapeHtml(serviceLineTitle(item.service))}</strong>` +
        `<span>${escapeHtml(serviceLineMeta(item.service) || 'Details vary by service')}</span>` +
        (serviceDisplayPrice(item.service) ? `<b class="as-booking-drawer__visit-line-price">${escapeHtml(serviceDisplayPrice(item.service))}</b>` : '') +
        '</div>' +
        '<div class="as-booking-drawer__visit-line-actions">' +
        `<button type="button" class="as-booking-drawer__visit-move" data-booking-move-line="${escapeHtml(item.id)}" data-booking-move-direction="up" aria-label="${escapeHtml(`Move ${serviceLineTitle(item.service)} earlier`)}" ${item.index === 0 ? 'disabled' : ''}>Up</button>` +
        `<button type="button" class="as-booking-drawer__visit-move" data-booking-move-line="${escapeHtml(item.id)}" data-booking-move-direction="down" aria-label="${escapeHtml(`Move ${serviceLineTitle(item.service)} later`)}" ${item.index === items.length - 1 ? 'disabled' : ''}>Down</button>` +
        `<button type="button" data-booking-remove-line="${escapeHtml(item.id)}" aria-label="${escapeHtml(`Remove ${serviceLineTitle(item.service)}`)}">Remove</button>` +
        '</div>' +
        '</div>'
      )),
      '</div>',
      '<p>Add any other service from the list above, including the same service again for a group visit.</p>',
      '</div>',
    ].join('');

    bookingSegmentList.hidden = true;
    bookingSegmentList.innerHTML = '';
    bookingAddOnList.innerHTML = [
      '<h4>Add another service</h4>',
      '<p class="as-booking-drawer__empty">Use the service list to add another treatment. Re-select a service when booking for more than one person.</p>',
    ].join('');
  };

  const renderProviderFilter = () => {
    if (!bookingProviderFilter || !bookingProviderFilterList) return;

    const providers = concreteTeamMembers();
    const showProviderFilter = serviceEntryMode === 'providers';
    if (!showProviderFilter || !providers.length) {
      bookingProviderFilter.hidden = true;
      bookingProviderFilterList.innerHTML = '';
      if (bookingProviderFilterStatus) bookingProviderFilterStatus.textContent = '';
      return;
    }

    const activeIds = effectiveServiceProviderFilterIds();
    const choices = [
      { id: 'any', label: 'All providers' },
      ...providers,
    ];

    bookingProviderFilter.hidden = false;
    bookingProviderFilterList.innerHTML = choices.map((provider) => {
      const isClearButton = provider.id === 'any';
      const isActive = isClearButton ? !activeIds.length : activeIds.includes(provider.id);
      const label = isClearButton ? provider.label : provider.label.split(/\s+/)[0];
      return (
        `<button type="button" data-booking-provider-filter-choice="${escapeHtml(provider.id)}" data-booking-provider-slug="${escapeHtml(providerSlug(provider))}" aria-pressed="${String(isActive)}" aria-label="${escapeHtml(isClearButton ? 'Show all providers' : `Select ${provider.label}`)}">` +
        `${escapeHtml(label)}` +
        '</button>'
      );
    }).join('');

    if (bookingProviderFilterStatus) {
      bookingProviderFilterStatus.textContent = activeIds.length
        ? `${formatProviderList(activeIds)} selected. Showing services assigned to ${activeIds.length === 1 ? 'this provider' : 'these providers'}.`
        : 'Choose one or more providers to filter the service menu.';
    }
  };

  const renderServiceEntryMode = () => {
    bookingEntryModeButtons.forEach((button) => {
      const mode = cleanText(button.dataset.bookingEntryMode || 'services');
      button.setAttribute('aria-pressed', String(mode === serviceEntryMode));
    });
  };

  const closeVariationChooser = () => {
    activeVariationChooser = null;
    if (bookingVariationModal) bookingVariationModal.hidden = true;
    if (bookingVariationList) bookingVariationList.innerHTML = '';
  };

  const variationChooserSelectedCount = () => {
    if (!activeVariationChooser?.group?.services?.length) return 0;
    return activeVariationChooser.group.services.reduce(
      (total, service) => total + selectedLineCountForService(service.slug),
      0,
    );
  };

  const continueVariationChooser = () => {
    if (!activeVariationChooser || !variationChooserSelectedCount()) return;
    const shouldAdvanceToStaff = bookingStep === 1 && stepReady(1);
    closeVariationChooser();
    if (shouldAdvanceToStaff) {
      setBookingStep(2);
      return;
    }
    renderBookingCatalog();
    setFooterState();
  };

  const renderVariationChooser = () => {
    if (!bookingVariationModal || !bookingVariationList || !activeVariationChooser) return;
    const { group, mode } = activeVariationChooser;
    const isAddon = mode === 'addon';
    const selectedCount = variationChooserSelectedCount();
    const selectedLabel = selectedCount === 1 ? '1 service selected' : `${selectedCount} services selected`;
    const continueLabel = isAddon ? 'Continue with visit' : 'Continue to staff';

    if (bookingVariationTitle) bookingVariationTitle.textContent = group.label;
    if (bookingVariationKicker) bookingVariationKicker.textContent = isAddon ? 'Add service options' : 'Choose an option';

    const optionHtml = group.services.map((service) => {
      const selectedCount = selectedLineCountForService(service.slug);
      const selected = selectedCount > 0;
      const description = serviceDescription(service);
      const price = serviceDisplayPrice(service);

      return (
        `<div class="as-booking-drawer__variation-option" data-booking-variation-option="${escapeHtml(service.slug)}">` +
        `<button type="button" data-booking-variation-slug="${escapeHtml(service.slug)}" aria-pressed="${String(selected)}">` +
        `<span>${escapeHtml(variationOptionTitle(service, group.label))}</span>` +
        `<small>${escapeHtml(serviceMeta(service))}</small>` +
        (price ? `<strong class="as-booking-drawer__service-price">${escapeHtml(price)}</strong>` : '') +
        (description ? `<em>${escapeHtml(description)}</em>` : '') +
        '</button>' +
        '<div class="as-booking-drawer__quantity" aria-label="Service quantity">' +
        `<button type="button" data-booking-service-quantity="decrease" data-booking-service-slug="${escapeHtml(service.slug)}" aria-label="${escapeHtml(`Remove one ${service.title}`)}" ${selectedCount ? '' : 'disabled'}>−</button>` +
        `<span aria-live="polite">${escapeHtml(String(selectedCount))}</span>` +
        `<button type="button" data-booking-service-quantity="increase" data-booking-service-slug="${escapeHtml(service.slug)}" aria-label="${escapeHtml(`Add one ${service.title}`)}">+</button>` +
        '</div>' +
        '</div>'
      );
    }).join('');

    bookingVariationList.innerHTML = [
      optionHtml,
      '<div class="as-booking-drawer__variation-actions">',
      `<span aria-live="polite">${escapeHtml(selectedCount ? selectedLabel : 'Choose at least one option to continue.')}</span>`,
      `<button type="button" data-booking-variation-next ${selectedCount ? '' : 'disabled'}>${escapeHtml(continueLabel)}</button>`,
      '</div>',
    ].join('');

    bookingVariationModal.hidden = false;
  };

  const openVariationChooser = (group, mode = 'primary') => {
    if (!group?.services?.length) return;
    activeVariationChooser = { group, mode };
    renderVariationChooser();
  };

  const pruneProviderSelections = () => {
    const segments = selectedVisitSegments();
    const validSegmentIds = new Set(segments.map((segment) => segment.segmentId));
    const nextProvidersBySegment = {};
    const validItemIds = new Set(selectedLineItems().map((item) => item.id));
    const nextProvidersByItem = {};

    Object.entries(selectedProvidersBySegment).forEach(([segmentId, providerId]) => {
      const segment = segments.find((candidate) => candidate.segmentId === segmentId);
      if (!segment || !validSegmentIds.has(segmentId)) return;
      if (providerId === 'any') {
        nextProvidersBySegment[segmentId] = providerId;
      } else if (providerId && providersForSegment(segment).some((provider) => provider.id === providerId)) {
        nextProvidersBySegment[segmentId] = providerId;
      }
    });

    selectedProvidersBySegment = nextProvidersBySegment;

    Object.entries(selectedProvidersByItem).forEach(([itemId, providerId]) => {
      const item = selectedLineItems().find((candidate) => candidate.id === itemId);
      if (!item || !validItemIds.has(itemId)) return;
      if (providerId === 'any') {
        nextProvidersByItem[itemId] = providerId;
      } else if (providerId && providersForLineItem(item).some((provider) => provider.id === providerId)) {
        nextProvidersByItem[itemId] = providerId;
      }
    });

    selectedProvidersByItem = nextProvidersByItem;

    if (
      selectedProviderId !== 'any' &&
      !commonProvidersForSelectedVisit().some((provider) => provider.id === selectedProviderId)
    ) {
      selectedProviderId = 'any';
    }
  };

  const renderProviderControls = () => {
    normalizeProviderModeForVisit();
    pruneProviderSelections();
    if (
      effectiveServiceProviderFilterIds().length &&
      selectedLineItems().some((item) => !Object.prototype.hasOwnProperty.call(selectedProvidersByItem, item.id))
    ) {
      syncProviderFilterAssignments();
      pruneProviderSelections();
    }

    bookingProviderButtons.forEach((button) => {
      const providerMode = cleanText(button.dataset.bookingProvider || '');
      const pressed = providerMode === 'first_available'
        ? selectedProviderMode === 'first_available'
        : selectedProviderMode !== 'first_available';
      button.setAttribute('aria-pressed', String(pressed));
    });

    if (bookingProviderPanel) bookingProviderPanel.hidden = selectedProviderMode !== 'same_provider_if_possible';
    if (bookingSegmentProviderList) bookingSegmentProviderList.hidden = selectedProviderMode !== 'provider_per_service';

    if (!selectedLineItems().length) {
      if (bookingProviderList) bookingProviderList.innerHTML = '';
      if (bookingSegmentProviderList) bookingSegmentProviderList.innerHTML = '';
      if (bookingProviderStatus) bookingProviderStatus.textContent = '';
      return;
    }

    const commonProviders = commonProvidersForSelectedVisit();

    if (bookingProviderList) {
      bookingProviderList.innerHTML = commonProviders.map((provider) => (
        `<button type="button" data-booking-provider-id="${escapeHtml(provider.id)}" aria-pressed="${String(selectedProviderId === provider.id)}">` +
        `${escapeHtml(provider.label)}` +
        '</button>'
      )).join('') || '<p class="as-booking-drawer__empty">No single staff member is available for every selected service.</p>';
    }

    if (bookingSegmentProviderList) {
      const items = selectedLineItems();
      const activeFilterIds = effectiveServiceProviderFilterIds();
      const renderAssignmentCounts = Object.fromEntries(activeFilterIds.map((id) => [id, 0]));
      bookingSegmentProviderList.innerHTML = [
        '<h4>Choose staff for each service</h4>',
        ...items.map((item) => {
          const providers = providersForLineItem(item);
          let selected = Object.prototype.hasOwnProperty.call(selectedProvidersByItem, item.id)
            ? selectedProvidersByItem[item.id]
            : '';
          if (!selected && activeFilterIds.length) {
            const compatibleFilterIds = activeFilterIds.filter((id) => (
              providers.some((provider) => provider.id === id)
            ));
            if (compatibleFilterIds.length) {
              selected = compatibleFilterIds
                .slice()
                .sort((first, second) => (renderAssignmentCounts[first] || 0) - (renderAssignmentCounts[second] || 0))[0];
              selectedProvidersByItem[item.id] = selected;
            }
          }
          if (selected && renderAssignmentCounts[selected] !== undefined) {
            renderAssignmentCounts[selected] += 1;
          }
          const choices = [
            { id: 'any', label: 'Any staff' },
            ...providers,
          ];

          return (
            `<div class="as-booking-drawer__segment-provider" data-booking-line-provider-row="${escapeHtml(item.id)}">` +
            '<div>' +
            `<small>${escapeHtml(`Service ${item.index + 1}`)}</small>` +
            `<strong>${escapeHtml(serviceLineTitle(item.service))}</strong>` +
            `<em>${escapeHtml(selected ? providerName(selected) : 'Choose any staff or a specific tech')}</em>` +
            '</div>' +
            '<div class="as-booking-drawer__staff-list">' +
            choices.map((provider) => (
              `<button type="button" data-booking-line-provider="${escapeHtml(provider.id)}" data-booking-line-id="${escapeHtml(item.id)}" aria-pressed="${String(selected === provider.id)}">` +
              `${escapeHtml(provider.label)}` +
              '</button>'
            )).join('') +
            (!providers.length ? '<p class="as-booking-drawer__empty">We will look for the first compatible staff member for this service.</p>' : '') +
            '</div>' +
            '</div>'
          );
        }),
      ].join('');
    }

    if (bookingProviderStatus) {
      const capabilities = bookingTeam.capabilities || {};
      const status = [];

      if (capabilities.source === 'square' && capabilities.skipStaffSelection) {
        status.push('Any staff is recommended for the fastest opening.');
      } else if (selectedProviderMode === 'same_provider_if_possible' && !commonProviders.length) {
        status.push('No single staff member is available for every selected service.');
      } else if (selectedProviderMode === 'provider_per_service') {
        status.push(providerSelectionReady() ? 'Staff preference selected for each service.' : 'Choose any staff or a specific tech for each service.');
      } else if (selectedProviderMode === 'same_provider_if_possible' && selectedProviderId !== 'any') {
        status.push(`${providerName(selectedProviderId)} selected.`);
      } else if (selectedProviderMode === 'same_provider_if_possible') {
        status.push('Choose a staff member to continue.');
      } else {
        status.push('Any available staff will show the fastest compatible openings.');
      }

      if (capabilities.source === 'square' && capabilities.multipleServiceBookingEnabled === false && selectedServices().length > 1) {
        status.push('This service combination needs staff review before it can be booked online.');
      }

      bookingProviderStatus.textContent = status.join(' ');
    }
  };

  const availabilitySignature = () => JSON.stringify({
    date: bookingDate?.value || '',
    items: selectedLineItems().map((item) => ({
      id: item.id,
      serviceSlug: item.service.slug,
    })),
    providerMode: selectedProviderMode,
    providerId: selectedProviderId,
    providersBySegment: selectedProvidersBySegment,
    providersByItem: selectedProvidersByItem,
  });

  const resetAvailabilitySelection = () => {
    selectedSlot = null;
    selectedSlotsByItem = {};
    selectedSlotsByDate = {};
    bookingSlots = [];
    bookingSlotsByItem = {};
    squareToken = '';
    availabilitySearchSignature = '';
    activeBookingDateValue = currentBookingDateValue();
  };

  const resetAvailabilityForDateChange = (nextDateValue = currentBookingDateValue()) => {
    activeBookingDateValue = cleanText(nextDateValue) || defaultBookingDateValue();
    selectedSlot = null;
    selectedSlotsByItem = {};
    selectedSlotsByDate = {};
    bookingSlots = [];
    bookingSlotsByItem = {};
    squareToken = '';
    availabilitySearchSignature = '';
  };

  const renderDateStrip = () => {
    if (!bookingDateList) return;
    if (bookingDate && !bookingDate.value) bookingDate.value = defaultBookingDateValue();
    if (!activeBookingDateValue) activeBookingDateValue = bookingDate?.value || defaultBookingDateValue();

    const selectedValue = bookingDate?.value || defaultBookingDateValue();
    const selectedDate = dateFromInputValue(selectedValue);
    const dates = Array.from({ length: 5 }, (_, index) => {
      const date = new Date(selectedDate);
      date.setDate(selectedDate.getDate() + index);
      return date;
    });

    bookingDateList.innerHTML = dates.map((date) => {
      const value = dateInputValue(date);
      const parts = dateParts(date);
      const selected = value === selectedValue;

      return (
        `<button class="${selected ? 'is-selected' : ''}" type="button" role="listitem" data-booking-date-option="${escapeHtml(value)}" aria-pressed="${String(selected)}" aria-label="${escapeHtml(`${parts.weekday}, ${parts.month} ${parts.day}`)}">` +
        `<span>${escapeHtml(parts.weekday)}</span>` +
        `<strong>${escapeHtml(parts.day)}</strong>` +
        `<small>${escapeHtml(parts.month)}</small>` +
        '</button>'
      );
    }).join('');
  };

  const setBookingDateValue = (value) => {
    const nextValue = cleanText(value);
    if (!bookingDate || !nextValue) return;
    resetAvailabilityForDateChange(nextValue);
    bookingDate.value = activeBookingDateValue;
    renderDateStrip();
    renderSlots();
    renderBookingSummary();
    setFooterState();

    if (bookingStep === 3) {
      searchAvailability({ force: true }).catch(() => {});
    }
  };

  const renderSlots = () => {
    if (!bookingSlotList) return;
    const items = selectedLineItems();

    if (!items.length) {
      renderAvailabilityActions({ missingCount: 0 });
      bookingSlotList.innerHTML = '<p class="as-booking-drawer__empty">Add a service before choosing a time.</p>';
      return;
    }

    const hasAnySlots = items.some((item) => (bookingSlotsByItem[item.id] || []).length);

    if (!hasAnySlots) {
      bookingSlotList.innerHTML = '<p class="as-booking-drawer__empty">Openings will appear here for the selected day.</p>';
      return;
    }

    bookingSlotList.innerHTML = items.map((item) => {
      const slots = bookingSlotsByItem[item.id] || [];
      const selected = selectedSlotsByItem[item.id] || null;
      const durationLabel = formatDuration(item.service.durationMinutes);

      return (
        `<section class="as-booking-drawer__line-slots" data-booking-line-slots="${escapeHtml(item.id)}">` +
        '<div class="as-booking-drawer__line-slots-head">' +
        `<small>${escapeHtml(`Service ${item.index + 1}`)}</small>` +
        '<div class="as-booking-drawer__line-slots-title">' +
        `<strong>${escapeHtml(serviceLineTitle(item.service))}</strong>` +
        (durationLabel ? `<em>${escapeHtml(durationLabel)}</em>` : '') +
        '</div>' +
        `<span>${escapeHtml(providerName(providerIdForLineItem(item)))}</span>` +
        '</div>' +
        (slots.length
          ? '<div class="as-booking-drawer__slot-grid">' +
            slots.map((slot, index) => {
              const pressed = Boolean(selected && slotsMatch(selected, slot));
              const sameLineHoldDetail = !pressed ? sameLineDurationHoldDetail(item.id, slot) : { conflict: false, reason: '', label: '' };
              const conflictDetail = !pressed && !sameLineHoldDetail.conflict
                ? slotConflictDetail(item.id, slot)
                : sameLineHoldDetail;
              const conflicts = conflictDetail.conflict;
              const label = `${serviceLineTitle(item.service)}, ${formatDateTime(slot.startAt)}`;
              const disabledLabel = conflicts ? `${label}, ${conflictDetail.reason}` : label;

              return (
                `<button type="button" data-booking-slot-item-id="${escapeHtml(item.id)}" data-booking-slot-index="${index}" aria-pressed="${String(pressed)}" aria-label="${escapeHtml(disabledLabel)}" title="${escapeHtml(conflictDetail.reason)}" ${conflicts ? 'disabled' : ''}>` +
                `<span>${escapeHtml(formatTimeOnly(slot.startAt))}</span>` +
                (conflicts ? `<small>${escapeHtml(conflictDetail.label || 'Blocked')}</small>` : '') +
                '</button>'
              );
            }).join('') +
            '</div>'
          : '<p class="as-booking-drawer__empty">No openings found for this service on this day.</p>') +
        '</section>'
      );
    }).join('');
  };

  const renderBookingCatalog = () => {
    renderServiceTypes();
    renderCategories();
    renderServiceEntryMode();
    renderProviderFilter();
    renderServiceList();
    renderSelectedService();
    renderProviderControls();
    renderDateStrip();
    renderSlots();
    renderBookingSummary();
  };

  const hasDetails = () =>
    Boolean(
      cleanText(bookingFirstName?.value) &&
      cleanText(bookingLastName?.value) &&
      (cleanText(bookingPhone?.value) || cleanText(bookingEmail?.value)),
    );

  const stepReady = (step = bookingStep) => {
    if (step === 0) return Boolean(catalogServices().length);
    if (step === 1) return Boolean(selectedLineItems().length);
    if (step === 2) return Boolean(selectedLineItems().length && providerSelectionReady());
    if (step === 3) return allSlotsSelected();
    if (step === 4) {
      return Boolean(
        hasDetails() &&
          bookingPolicyConfirm?.checked &&
          paymentConfigLoaded() &&
          (!cardCaptureRequired() || squareCardReady),
      );
    }
    if (step === 5) {
      return Boolean(
          allSlotsSelected() &&
          hasDetails() &&
          bookingPolicyConfirm?.checked &&
          paymentConfigLoaded() &&
          (!cardCaptureRequired() || squareToken),
      );
    }
    return true;
  };

  const setFooterState = () => {
    if (bookingBack) bookingBack.disabled = bookingStep === 0 || bookingCreated;
    if (!bookingNext) return;
    bookingNext.hidden = bookingCreated;
    bookingNext.disabled = !stepReady(bookingStep);
    bookingNext.textContent = bookingStep === bookingSteps.length - 1
      ? cardCaptureRequired()
        ? 'Confirm booking'
        : 'Finish on Square'
      : bookingStep === 0
        ? 'Choose service'
      : bookingStep === 1
        ? 'Choose staff'
      : bookingStep === 2
        ? 'Find a time'
      : bookingStep === 4
        ? 'Continue to confirmation'
        : 'Continue';
  };

  const updateDrawerStageState = () => {
    bookingDrawer.classList.toggle('as-booking-drawer--visit-ready', Boolean(selectedLineItems().length || bookingStep > 1));
    bookingDrawer.dataset.bookingStage = String(bookingStep);
  };

  const setBookingStep = (step) => {
    const nextStep = Math.max(0, Math.min(bookingSteps.length - 1, step));
    bookingDrawer.dataset.bookingDirection = nextStep >= bookingStep ? 'forward' : 'back';
    bookingStep = nextStep;
    bookingSteps.forEach((panel, index) => panel.classList.toggle('is-active', index === bookingStep));
    bookingProgress.forEach((button, index) => {
      if (index === bookingStep) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
    if (bookingStep !== 5 && !bookingCreated) setReviewStatus('');
    updateDrawerStageState();
    renderProviderControls();
    renderDateStrip();
    renderBookingSummary();
    setFooterState();

    if (bookingStep === 4) syncCardholderName();

    if (bookingStep === 3) {
      if (bookingDate && !bookingDate.value) bookingDate.value = defaultBookingDateValue();
      renderDateStrip();
      searchAvailability({ force: false }).catch(() => {});
    }

    if (bookingStep === 4) {
      ensureBookingConfig().then(() => {
        renderPaymentVisibility();
        setFooterState();
        if (cardCaptureRequired()) initializeSquareCard().catch(() => {});
      });
    }
  };

  const resetBookingProgress = () => {
    resetAvailabilitySelection();
    bookingCreated = false;
    bookingCreateActive = false;
    setReviewStatus('');
    if (bookingConfirmation) {
      bookingConfirmation.hidden = true;
      bookingConfirmation.innerHTML = '';
    }
    renderSlots();
    renderProviderControls();
    renderBookingSummary();
    setFooterState();
  };

  const refreshVisitAfterServiceChange = (service = null) => {
    syncSelectedService();
    selectedAddOns = new Set();
    selectedProvidersBySegment = {};
    const lineItems = selectedLineItems();
    if (!lineItems.length) {
      selectedProviderMode = 'first_available';
      selectedProviderId = 'any';
      selectedProvidersByItem = {};
    } else if (effectiveServiceProviderFilterIds().length) {
      syncProviderFilterAssignments();
    } else if (lineItems.length > 1) {
      selectedProviderMode = 'provider_per_service';
      selectedProviderId = 'any';
    } else if (selectedProviderMode !== 'first_available') {
      selectedProviderMode = 'same_provider_if_possible';
    }
    if (selectedProviderMode === 'same_provider_if_possible' && selectedProviderId !== 'any' && !serviceAllowsProvider(service, selectedProviderId)) {
      selectedProviderId = 'any';
    }
    resetBookingProgress();
    renderBookingCatalog();
    updateDrawerStageState();
    setFooterState();
  };

  const setSelectedService = (service) => {
    if (!service) return;
    if (selectedLineCountForService(service.slug)) return;
    addVisitItemForService(service);
    refreshVisitAfterServiceChange(service);
  };

  const changeServiceQuantity = (serviceSlug = '', action = 'increase') => {
    const service = serviceBySlug(serviceSlug);
    if (!service) return;

    if (action === 'decrease') {
      removeLastVisitItemForService(service.slug);
    } else {
      addVisitItemForService(service);
    }

    refreshVisitAfterServiceChange(service);
  };

  const removeVisitItem = (itemId = '') => {
    if (!itemId) return;
    visitItems = visitItems.filter((item) => item.id !== itemId);
    delete selectedProvidersByItem[itemId];
    removeSlotSelectionForItem(itemId);
    delete bookingSlotsByItem[itemId];
    syncSelectedService();
    selectedAddOns = new Set();
    selectedProvidersBySegment = {};
    const lineItems = selectedLineItems();
    if (!lineItems.length) {
      selectedProviderMode = 'first_available';
      selectedProviderId = 'any';
      selectedProvidersByItem = {};
    } else if (effectiveServiceProviderFilterIds().length) {
      syncProviderFilterAssignments();
    } else if (lineItems.length > 1) {
      selectedProviderMode = 'provider_per_service';
      selectedProviderId = 'any';
    }
    resetAvailabilitySelection();
    renderBookingCatalog();
    updateDrawerStageState();
    setFooterState();
  };

  const moveVisitItem = (itemId = '', direction = 0) => {
    const id = cleanText(itemId);
    const offset = Number(direction);
    const index = visitItems.findIndex((item) => item.id === id);
    const targetIndex = index + offset;
    if (!id || !Number.isFinite(offset) || index < 0 || targetIndex < 0 || targetIndex >= visitItems.length) return;

    const nextItems = [...visitItems];
    [nextItems[index], nextItems[targetIndex]] = [nextItems[targetIndex], nextItems[index]];
    visitItems = nextItems;
    syncSelectedService();
    resetAvailabilitySelection();
    renderBookingCatalog();
    updateDrawerStageState();
    setFooterState();

    if (bookingStep === 3 && providerSelectionReady()) {
      searchAvailability({ force: true }).catch(() => {});
    }
  };

  const ensureBookingTeam = () => {
    if (bookingTeamPromise) return bookingTeamPromise;

    bookingTeamPromise = fetchTeam().then((payload) => {
      bookingTeam = normalizeTeam(payload);
      renderBookingCatalog();
      return bookingTeam;
    }).catch(() => {
      bookingTeam = {
        state: 'fallback',
        team: [{ id: 'any', label: 'Any available staff', bookable: true }],
        capabilities: {},
      };
      renderBookingCatalog();
      return bookingTeam;
    });

    return bookingTeamPromise;
  };

  const ensureBookingCatalog = () => {
    if (bookingCatalogPromise) return bookingCatalogPromise;

    if (bookingServiceStatus) {
      bookingServiceStatus.hidden = false;
      bookingServiceStatus.textContent = 'Loading services...';
    }

    bookingCatalogPromise = (async () => {
      const loadCatalog = async (url, source) => {
        const payload = await fetchCatalog(url);
        const catalog = normalizeCatalog(payload);

        if (!catalog.services.length) {
          throw new Error(`${source} catalog returned no public bookable services.`);
        }

        bookingCatalogSource = source;
        return catalog;
      };

      try {
        bookingCatalog = await loadCatalog(servicesApiUrl, 'live');
      } catch {
        bookingCatalog = await loadCatalog(servicesAssetUrl, 'snapshot');
      }

      renderBookingCatalog();

      return bookingCatalog;
    })().catch((error) => {
      bookingCatalogSource = 'unavailable';
      if (bookingServiceStatus) {
        bookingServiceStatus.hidden = false;
        bookingServiceStatus.textContent = 'Services could not load. Please try again in a moment.';
      }
      throw error;
    });

    return bookingCatalogPromise;
  };

  const openBookingDrawer = (link) => {
    bookingReturnFocus = link || document.activeElement;
    if (bookingDate && !bookingDate.value) bookingDate.value = defaultBookingDateValue();
    selectedService = null;
    selectedAddOns = new Set();
    visitItems = [];
    selectedCategories = new Set();
    selectedProviderMode = 'first_available';
    selectedProviderId = 'any';
    serviceEntryMode = 'services';
    serviceProviderFilterIds = new Set();
    setRememberedServiceProviderFilterIds([]);
    selectedProvidersBySegment = {};
    selectedProvidersByItem = {};
    selectedSlotsByItem = {};
    bookingSlotsByItem = {};
    resetBookingProgress();
    if (bookingServiceSearch) bookingServiceSearch.value = '';
    setBookingStep(0);
    bookingDrawer.hidden = false;
    document.body.classList.add('as-booking-drawer-open');
    window.requestAnimationFrame(() => bookingPanel?.focus({ preventScroll: true }));

    Promise.all([ensureBookingCatalog(), ensureBookingConfig(), ensureBookingTeam()]).then(() => {
      const matchedService = serviceFromLink(link);
      const matchedGroup = matchedService ? null : serviceGroupFromLink(link);
      const matchedProvider = providerFromLink(link);

      if (matchedProvider?.id && cleanText(matchedProvider.id) !== 'any') {
        serviceEntryMode = 'providers';
        serviceProviderFilterIds = new Set([cleanText(matchedProvider.id)]);
        setRememberedServiceProviderFilterIds(activeServiceProviderFilterIds());
        selectedProviderMode = 'same_provider_if_possible';
        selectedProviderId = cleanText(matchedProvider.id);
      }

      if (matchedService) {
        selectedCategories.add(cleanText(matchedService.category || 'Other'));
        setSelectedService(matchedService);
        setBookingStep(1);
      } else if (matchedGroup) {
        selectedCategories.add(cleanText(matchedGroup.category || categoryFromLink(link) || 'Other'));
        if (matchedGroup.services.length === 1 && !matchedGroup.isVariantGroup) {
          setSelectedService(matchedGroup.services[0]);
        } else {
          renderBookingCatalog();
          window.requestAnimationFrame(() => openVariationChooser(matchedGroup, 'primary'));
        }
        setBookingStep(1);
      } else {
        const linkedCategory = categoryFromLink(link);
        if (linkedCategory) {
          selectedCategories.add(linkedCategory);
          setBookingStep(1);
        }
        renderBookingCatalog();
      }

      setFooterState();
    }).catch(() => {});
  };

  const closeBookingDrawer = () => {
    closeVariationChooser();
    bookingDrawer.hidden = true;
    document.body.classList.remove('as-booking-drawer-open');
    if (bookingReturnFocus && typeof bookingReturnFocus.focus === 'function') {
      bookingReturnFocus.focus({ preventScroll: true });
    }
  };

  const selectedFallbackBookingUrl = () =>
    selectedLineItems().find((item) => cleanText(item.service.fallbackBookingUrl))?.service.fallbackBookingUrl ||
    bookingCatalog.fallbackBookingUrl ||
    fallbackBookingUrl;

  const renderAvailabilityActions = ({ missingCount = 0, searching = false } = {}) => {
    if (!bookingAvailabilityActions) return;
    const items = selectedLineItems();

    if (!items.length || !missingCount) {
      bookingAvailabilityActions.hidden = true;
      bookingAvailabilityActions.innerHTML = '';
      return;
    }

    const waitlistUrl = selectedFallbackBookingUrl();

    bookingAvailabilityActions.hidden = false;
    bookingAvailabilityActions.innerHTML = [
      '<div>',
      '<strong>No complete opening on this day.</strong>',
      '<span>Jump to the next day with openings for your full visit, or join the waitlist.</span>',
      '</div>',
      `<button type="button" data-booking-next-available ${searching ? 'disabled' : ''}>${searching ? 'Finding next available...' : 'Go to next available'}</button>`,
      `<a href="${escapeHtml(waitlistUrl)}" target="_blank" rel="noopener" data-booking-waitlist>Join the waitlist</a>`,
    ].join('');
  };

  const fetchAvailabilityForItems = async (dateValue, items = selectedLineItems()) => {
    const range = dayRange(dateValue);
    const settled = await Promise.allSettled(items.map(async (item) => {
      const providerId = providerIdForLineItem(item);
      const result = await apiJson(availabilityApiUrl, {
        method: 'POST',
        body: JSON.stringify({
          serviceSlug: item.service.slug,
          serviceSlugs: [item.service.slug],
          providerMode: providerId && providerId !== 'any' ? 'same_provider_if_possible' : 'first_available',
          providerId: providerId || 'any',
          teamMemberId: providerId || 'any',
          ...range,
        }),
      });

      return {
        itemId: item.id,
        serviceTitle: serviceLineTitle(item.service),
        message: result.message || '',
        slots: Array.isArray(result.slots) ? result.slots : [],
      };
    }));
    const slotsByItem = {};
    const messages = [];

    settled.forEach((result, index) => {
      const item = items[index];
      if (result.status === 'fulfilled') {
        slotsByItem[item.id] = result.value.slots;
        if (!result.value.slots.length && result.value.message) {
          messages.push(`${serviceLineTitle(item.service)}: ${result.value.message}`);
        }
        return;
      }

      slotsByItem[item.id] = [];
      messages.push(`${serviceLineTitle(item.service)}: ${result.reason?.message || 'No openings found.'}`);
    });

    const missingCount = items.filter((item) => !(slotsByItem[item.id] || []).length).length;

    return {
      slotsByItem,
      messages,
      missingCount,
      hasCompleteAvailability: Boolean(items.length && missingCount === 0),
    };
  };

  const goToNextAvailable = async () => {
    const items = selectedLineItems();
    if (!items.length || !providerSelectionReady() || nextAvailableSearchActive) return;

    nextAvailableSearchActive = true;
    renderAvailabilityActions({ missingCount: items.length, searching: true });
    if (bookingAvailabilityStatus) bookingAvailabilityStatus.textContent = 'Looking for the next available day...';

    try {
      let probeDate = bookingDate?.value || defaultBookingDateValue();

      for (let offset = 1; offset <= 60; offset += 1) {
        probeDate = addDaysToDateValue(bookingDate?.value || defaultBookingDateValue(), offset);
        const result = await fetchAvailabilityForItems(probeDate, items);

        if (!result.hasCompleteAvailability) continue;

        if (bookingDate) bookingDate.value = probeDate;
        activeBookingDateValue = probeDate;
        selectedSlotsByItem = {};
        bookingSlotsByItem = result.slotsByItem;
        bookingSlots = bookingSlotsByItem[items[0]?.id] || [];
        availabilitySearchSignature = availabilitySignature();
        renderDateStrip();
        renderSlots();
        renderBookingSummary();
        renderAvailabilityActions({ missingCount: 0 });
        if (bookingAvailabilityStatus) {
          const dateLabel = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Los_Angeles',
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          }).format(dateFromInputValue(probeDate));
          bookingAvailabilityStatus.textContent = `Next available openings found on ${dateLabel}. Choose an opening for each service.`;
        }
        setFooterState();
        return;
      }

      if (bookingAvailabilityStatus) {
        bookingAvailabilityStatus.textContent = 'No complete opening found in the next 60 days. Join the waitlist or try a different staff selection.';
      }
      renderAvailabilityActions({ missingCount: items.length });
    } catch (error) {
      if (bookingAvailabilityStatus) bookingAvailabilityStatus.textContent = error.message;
      renderAvailabilityActions({ missingCount: items.length });
    } finally {
      nextAvailableSearchActive = false;
    }
  };

  const searchAvailability = async ({ force = true } = {}) => {
    const items = selectedLineItems();
    if (!items.length || !providerSelectionReady()) return;
    if (bookingDate && !bookingDate.value) bookingDate.value = defaultBookingDateValue();

    const signature = availabilitySignature();
    if (!force && availabilitySearchSignature === signature) return;
    if (availabilitySearchActive) return;

    availabilitySearchActive = true;
    availabilitySearchSignature = signature;
    bookingSlots = [];
    bookingSlotsByItem = {};
    squareToken = '';
    renderSlots();
    renderAvailabilityActions({ missingCount: 0 });
    setFooterState();
    if (bookingAvailabilityStatus) bookingAvailabilityStatus.textContent = 'Finding openings...';

    try {
      const result = await fetchAvailabilityForItems(bookingDate?.value, items);

      bookingSlotsByItem = result.slotsByItem;
      bookingSlots = bookingSlotsByItem[items[0]?.id] || [];
      pruneSelectedSlotsToAvailability();
      renderSlots();
      if (bookingAvailabilityStatus) {
        bookingAvailabilityStatus.textContent = result.missingCount === items.length
          ? result.messages.join(' ') || 'No openings found for this date.'
          : result.missingCount
            ? `Choose an opening for each service. ${result.messages.join(' ')}`
            : 'Choose an opening for each service.';
      }
      renderAvailabilityActions({ missingCount: result.missingCount });
      setFooterState();
    } catch (error) {
      availabilitySearchSignature = '';
      if (bookingAvailabilityStatus) bookingAvailabilityStatus.textContent = error.message;
      renderAvailabilityActions({ missingCount: items.length });
    } finally {
      availabilitySearchActive = false;
    }
  };

  const createBooking = async () => {
    if (!stepReady(5) || bookingCreateActive || bookingCreated) return;

    try {
      bookingCreateActive = true;
      if (bookingNext) {
        bookingNext.disabled = true;
        bookingNext.textContent = 'Confirming...';
      }
      if (!cardCaptureRequired()) {
        window.location.href = selectedFallbackBookingUrl();
        return;
      }
      setReviewStatus('Confirming your booking with Square...', 'loading');
      setPaymentStatus(squareToken ? 'Card secured for this reservation.' : 'Securing card with Square...');
      const token = await tokenizeSquareCard();
      const verificationToken = await verifySquareBuyer(token);
      const items = selectedLineItems();
      const firstSlot = selectedSlotsByItem[items[0]?.id] || {};
      const payload = {
        ...bookingPayloadBase(),
        startAt: firstSlot.startAt,
        appointmentSegments: firstSlot.appointmentSegments || [],
        clientFirstName: cleanText(bookingFirstName?.value),
        clientLastName: cleanText(bookingLastName?.value),
        clientPhone: cleanText(bookingPhone?.value),
        clientEmail: cleanText(bookingEmail?.value),
        cardholderName: cleanText(bookingCardholderName?.value) || clientFullName(),
        notes: cleanText(bookingNotes?.value),
        paymentPolicyAccepted: Boolean(bookingPolicyConfirm?.checked),
        marketingOptIn: Boolean(bookingMarketingConfirm?.checked),
        cardOnFileRequired: true,
        sourceId: token,
        verificationToken,
        idempotencyKey: idempotencyKey('allsix-booking'),
        cardIdempotencyKey: idempotencyKey('as-card').slice(0, 45),
      };
      const result = await apiJson(createApiUrl, {
        method: 'POST',
        headers: { 'idempotency-key': payload.idempotencyKey },
        body: JSON.stringify(payload),
      });
      const confirmation = result.confirmation || {};
      const card = confirmation.cardOnFile || result.cardOnFile || {};
      const bookingIds = Array.isArray(confirmation.bookingIds) && confirmation.bookingIds.length
        ? confirmation.bookingIds
        : [confirmation.bookingId].filter(Boolean);
      if (!result.booked && result.state !== 'booked' && !bookingIds.length) {
        throw squareDisplayError(result, 'Square did not confirm this booking. Please try again.');
      }
      bookingCreated = true;
      if (bookingConfirmation) {
        const cardLabel = card.last4
          ? `${formatCardBrand(card.brand)} ending ${card.last4}`
          : 'Stored securely with Square';
        const confirmationLines = items.map((item, index) => {
          const bookingId = cleanText(bookingIds[index] || bookingIds[0] || '');
          const time = formatDateTime(selectedSlotsByItem[item.id]?.startAt) || 'Time confirmed';
          const provider = providerName(providerIdForLineItem(item));

          return (
            '<article class="as-booking-drawer__confirmation-line">' +
            '<div>' +
            `<small>Appointment ${index + 1}</small>` +
            `<strong>${escapeHtml(serviceLineTitle(item.service))}</strong>` +
            `<span>${escapeHtml(`${time}${provider ? ` with ${provider}` : ''}`)}</span>` +
            '</div>' +
            (bookingId ? `<em>Square reference ${escapeHtml(bookingId)}</em>` : '') +
            '</article>'
          );
        }).join('');

        bookingConfirmation.hidden = false;
        bookingConfirmation.innerHTML = [
          '<div class="as-booking-drawer__confirmation-head">',
          '<span aria-hidden="true">✓</span>',
          '<div>',
          `<strong>${escapeHtml(bookingIds.length > 1 ? 'Appointments reserved' : 'Appointment reserved')}</strong>`,
          '<p>Your reservation is confirmed. We will use the card on file only according to the cancellation policy.</p>',
          '</div>',
          '</div>',
          `<div class="as-booking-drawer__confirmation-lines">${confirmationLines}</div>`,
          '<div class="as-booking-drawer__confirmation-card">',
          '<span>Cancellation policy</span>',
          `<strong>${escapeHtml(cancellationPolicyMessage())}</strong>`,
          '</div>',
          '<div class="as-booking-drawer__confirmation-card">',
          '<span>Card on file</span>',
          `<strong>${escapeHtml(cardLabel)}</strong>`,
          '<small>Stored securely by Square. All Six does not store the full card number.</small>',
          '</div>',
        ].join('');
      }
      setPaymentStatus('Card stored with Square.');
      setReviewStatus('Appointment confirmed in Square.', 'success');
      setFooterState();
      focusBookingConfirmation();
    } catch (error) {
      squareToken = '';
      squareVerificationToken = '';
      bookingCreateActive = false;
      const displayError = squareDisplayError(error, 'Square could not complete this reservation.');
      setPaymentStatus(displayError.message, displayError);
      setReviewStatus(displayError.message, 'error');
      setFooterState();
      if (bookingNext) {
        bookingNext.hidden = false;
        bookingNext.disabled = false;
        bookingNext.textContent = 'Try again';
      }
    }
  };

  const continueBooking = async () => {
    if (bookingStep === 3 && !allSlotsSelected()) {
      if (!selectedLineItems().some((item) => (bookingSlotsByItem[item.id] || []).length)) await searchAvailability();
      return;
    }

    if (bookingStep === 4) {
      try {
        if (cardCaptureRequired()) {
          setPaymentStatus('Securing card with Square...');
          const token = await tokenizeSquareCard();
          await verifySquareBuyer(token);
        }
        setBookingStep(5);
      } catch (error) {
        const displayError = squareDisplayError(error, 'Square could not secure this card.');
        setPaymentStatus(displayError.message, displayError);
      }
      return;
    }

    if (bookingStep === 5) {
      await createBooking();
      return;
    }

    if (!stepReady(bookingStep)) return;
    setBookingStep(bookingStep + 1);
  };

  const bookingAppHealthReady = async (link) => {
    if (!link || link.dataset.bookingHealthFallback !== 'true') return true;
    const healthUrl = link.dataset.bookingHealthUrl || '';
    if (!healthUrl) return true;

    try {
      const response = await fetch(healthUrl, {
        credentials: 'omit',
        cache: 'no-store',
        headers: {
          accept: 'application/json',
        },
      });
      const payload = await response.json().catch(() => ({}));
      return Boolean(response.ok && payload.ok && payload.bookingApp);
    } catch {
      return false;
    }
  };

  document.addEventListener('click', async (event) => {
    const bookingAppLink = event.target.closest('a[data-booking-app-url]');
    if (bookingAppLink && !bookingAppLink.closest('[data-booking-drawer]')) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || bookingAppLink.target === '_blank') return;

      event.preventDefault();
      const fallbackUrl = bookingAppLink.dataset.squareFallbackUrl || fallbackBookingUrl;
      const healthy = await bookingAppHealthReady(bookingAppLink);
      window.location.href = healthy ? bookingAppLink.href : fallbackUrl;
      return;
    }

    const bookingLink = event.target.closest([
      'a[data-booking-open]',
      'a[href*="book.squareup.com/appointments"]',
      'a[href*="appointments.allsixsalon.com"]',
      'a[href*="booking=1"]',
      'a[href*="booking=true"]',
      'a[href*="booking=open"]',
      'a[href*="open=booking"]',
      'a[href*="#booking"]',
    ].join(', '));

    if (bookingLink && !bookingLink.closest('[data-booking-drawer]') && linkShouldOpenBooking(bookingLink)) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || bookingLink.target === '_blank') return;
      event.preventDefault();
      openBookingDrawer(bookingLink);
      return;
    }

    if (event.target.closest('[data-booking-close]')) {
      closeBookingDrawer();
    }
  });

  bookingServiceSearch?.addEventListener('input', renderServiceList);

  bookingServiceTypeList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-booking-service-type]');
    if (!button) return;
    const category = cleanText(button.dataset.bookingServiceType || '');
    if (!category) return;
    if (selectedCategories.has(category)) selectedCategories.delete(category);
    else selectedCategories.add(category);
    renderBookingCatalog();
    setFooterState();
  });

  bookingCategoryList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-booking-category]');
    if (!button) return;
    const category = cleanText(button.dataset.bookingCategory || '');
    if (!category) return;
    if (selectedCategories.has(category)) {
      selectedCategories.delete(category);
    } else if (!selectedCategories.has(category)) {
      selectedCategories.add(category);
    }
    renderBookingCatalog();
    setFooterState();
  });

  bookingEntryModeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const mode = cleanText(button.dataset.bookingEntryMode || 'services');
      serviceEntryMode = mode === 'providers' ? 'providers' : 'services';
      if (serviceEntryMode === 'services') {
        serviceProviderFilterIds = new Set();
        setRememberedServiceProviderFilterIds([]);
        selectedProvidersByItem = {};
        selectedProvidersBySegment = {};
      }
      closeVariationChooser();
      renderBookingCatalog();
      setFooterState();
    });
  });

  bookingProviderFilterList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-booking-provider-filter-choice]');
    if (!button) return;

    const providerId = cleanText(button.dataset.bookingProviderFilterChoice || 'any') || 'any';
    if (providerId === 'any') {
      serviceProviderFilterIds = new Set();
      setRememberedServiceProviderFilterIds([]);
      selectedProvidersByItem = {};
      selectedProvidersBySegment = {};
      selectedProviderMode = selectedLineItems().length > 1 ? 'provider_per_service' : 'first_available';
    } else {
      const nextProviderIds = new Set(serviceProviderFilterIds);
      if (nextProviderIds.has(providerId)) nextProviderIds.delete(providerId);
      else nextProviderIds.add(providerId);
      serviceProviderFilterIds = nextProviderIds;
      setRememberedServiceProviderFilterIds(activeServiceProviderFilterIds());
      selectedProvidersBySegment = {};
    }
    selectedProviderId = 'any';
    syncProviderFilterAssignments({ resetExisting: true });

    closeVariationChooser();
    resetAvailabilitySelection();
    resetBookingProgress();
    renderBookingCatalog();
    updateDrawerStageState();
    setFooterState();
  });

  bookingServiceList?.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-booking-service-quantity]');
    if (quantityButton) {
      changeServiceQuantity(quantityButton.dataset.bookingServiceSlug || '', quantityButton.dataset.bookingServiceQuantity || 'increase');
      return;
    }

    const groupButton = event.target.closest('[data-booking-service-group-key]');
    if (groupButton) {
      const group = findServiceChoiceGroup(groupButton.dataset.bookingServiceGroupKey || '');
      if (group) openVariationChooser(group, 'primary');
      return;
    }

    const button = event.target.closest('[data-booking-service-slug]');
    if (!button) return;
    const service = serviceBySlug(button.dataset.bookingServiceSlug);
    if (!service || selectedLineCountForService(service.slug)) return;
    setSelectedService(service);
  });

  bookingSelectedService?.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-booking-remove-line]');
    if (removeButton) {
      removeVisitItem(removeButton.dataset.bookingRemoveLine || '');
      return;
    }

    const moveButton = event.target.closest('[data-booking-move-line]');
    if (moveButton) {
      moveVisitItem(
        moveButton.dataset.bookingMoveLine || '',
        moveButton.dataset.bookingMoveDirection === 'up' ? -1 : 1,
      );
      return;
    }

    const button = event.target.closest('[data-booking-change-selected-service]');
    if (!button) return;
    const group = serviceChoiceGroups(catalogServices()).find((candidate) => candidate.key === button.dataset.bookingChangeSelectedService);
    if (group) openVariationChooser(group, 'primary');
  });

  bookingAddOnList?.addEventListener('change', (event) => {
    const input = event.target.closest('[data-booking-addon]');
    if (!input) return;
    if (input.checked) selectedAddOns.add(input.value);
    else selectedAddOns.delete(input.value);
    selectedProvidersBySegment = {};
    if (selectedProviderMode !== 'first_available') {
      selectedProviderMode = selectedServices().length > 1 ? 'provider_per_service' : 'same_provider_if_possible';
    }
    resetBookingProgress();
    renderSelectedService();
    renderProviderControls();
    renderBookingSummary();
  });

  bookingAddOnList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-booking-addon-group-key]');
    if (!button) return;
    const addOnSlugs = [...new Set([
      ...(Array.isArray(selectedService?.addOns) ? selectedService.addOns : []),
      ...(Array.isArray(selectedService?.canCombineWith) ? selectedService.canCombineWith : []),
    ])].filter((slug) => slug !== selectedService?.slug);
    const addOnServices = addOnSlugs.map((slug) => serviceBySlug(slug)).filter(Boolean);
    const group = serviceChoiceGroups(addOnServices).find((candidate) => candidate.key === button.dataset.bookingAddonGroupKey);
    if (group) openVariationChooser(group, 'addon');
  });

  bookingVariationModal?.addEventListener('click', (event) => {
    if (event.target.closest('[data-booking-variation-close]')) {
      closeVariationChooser();
      return;
    }

    if (event.target.closest('[data-booking-variation-next]')) {
      continueVariationChooser();
      return;
    }

    const quantityButton = event.target.closest('[data-booking-service-quantity]');
    if (quantityButton) {
      changeServiceQuantity(quantityButton.dataset.bookingServiceSlug || '', quantityButton.dataset.bookingServiceQuantity || 'increase');
      renderVariationChooser();
      return;
    }

    const button = event.target.closest('[data-booking-variation-slug]');
    if (!button || !activeVariationChooser) return;
    const service = serviceBySlug(button.dataset.bookingVariationSlug);
    if (!service) return;
    if (selectedLineCountForService(service.slug)) return;

    setSelectedService(service);
    closeVariationChooser();
  });

  bookingProviderButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const providerChoice = cleanText(button.dataset.bookingProvider || 'first_available');
      const items = selectedLineItems();
      selectedProviderMode = providerChoice === 'with_staff'
        ? items.length > 1
          ? 'provider_per_service'
          : 'same_provider_if_possible'
        : items.length > 1
          ? 'provider_per_service'
          : 'first_available';
      if (selectedProviderMode === 'first_available') {
        selectedProviderId = 'any';
        selectedProvidersBySegment = {};
        selectedProvidersByItem = {};
      } else if (providerChoice === 'first_available' && selectedProviderMode === 'provider_per_service') {
        selectedProviderId = 'any';
        selectedProvidersBySegment = {};
        selectedProvidersByItem = Object.fromEntries(items.map((item) => [item.id, 'any']));
      }
      resetBookingProgress();
      renderProviderControls();
      renderBookingSummary();
    });
  });

  bookingProviderList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-booking-provider-id]');
    if (!button) return;
    selectedProviderMode = 'same_provider_if_possible';
    selectedProviderId = cleanText(button.dataset.bookingProviderId || 'any') || 'any';
    resetBookingProgress();
    renderProviderControls();
    renderBookingSummary();
  });

  bookingSegmentProviderList?.addEventListener('click', (event) => {
    const lineButton = event.target.closest('[data-booking-line-provider]');
    if (lineButton) {
      const itemId = cleanText(lineButton.dataset.bookingLineId || '');
      const providerId = cleanText(lineButton.dataset.bookingLineProvider || 'any') || 'any';
      if (!itemId) return;
      selectedProviderMode = 'provider_per_service';
      selectedProvidersByItem[itemId] = providerId;
      resetBookingProgress();
      renderProviderControls();
      renderBookingSummary();
      return;
    }

    const button = event.target.closest('[data-booking-segment-provider]');
    if (!button) return;
    const segmentId = cleanText(button.dataset.bookingSegmentId || '');
    const providerId = cleanText(button.dataset.bookingSegmentProvider || 'any') || 'any';
    if (!segmentId) return;
    selectedProviderMode = 'provider_per_service';
    selectedProvidersBySegment[segmentId] = providerId;
    resetBookingProgress();
    renderProviderControls();
    renderBookingSummary();
  });

  bookingAvailabilityActions?.addEventListener('click', (event) => {
    const nextButton = event.target.closest('[data-booking-next-available]');
    if (!nextButton) return;
    goToNextAvailable().catch(() => {});
  });

  bookingSlotList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-booking-slot-index]');
    if (!button) return;
    const itemId = cleanText(button.dataset.bookingSlotItemId || '');
    const slots = itemId ? bookingSlotsByItem[itemId] || [] : bookingSlots;
    const slot = slots[Number(button.dataset.bookingSlotIndex || 0)] || null;
    if (!slot) return;
    if (itemId && sameLineDurationHoldDetail(itemId, slot).conflict) return;
    if (itemId && slotConflictsWithOtherLines(itemId, slot)) return;
    if (itemId) {
      if (slotsMatch(selectedSlotsByItem[itemId], slot)) {
        delete selectedSlotsByItem[itemId];
      } else {
        selectedSlotsByItem[itemId] = slot;
      }
      selectedSlot = selectedSlots()[0] || null;
    } else {
      const firstItem = selectedLineItems()[0];
      if (firstItem && slotsMatch(selectedSlotsByItem[firstItem.id], slot)) {
        delete selectedSlotsByItem[firstItem.id];
      } else if (firstItem) {
        selectedSlotsByItem[firstItem.id] = slot;
      }
      selectedSlot = selectedSlots()[0] || null;
    }
    persistSlotSelectionForDate();
    squareToken = '';
    renderSlots();
    renderBookingSummary();
    setFooterState();
  });

  [bookingFirstName, bookingLastName, bookingPhone, bookingEmail, bookingNotes].forEach((field) => {
    field?.addEventListener('input', () => {
      if (field === bookingFirstName || field === bookingLastName) syncCardholderName();
      invalidateCardToken();
      renderBookingSummary();
      setFooterState();
    });
  });

  bookingCardholderName?.addEventListener('input', () => {
    cardholderNameTouched = true;
    invalidateCardToken();
  });

  bookingPolicyConfirm?.addEventListener('change', () => {
    invalidateCardToken();
    renderBookingSummary();
    setFooterState();
  });
  bookingMarketingConfirm?.addEventListener('change', () => {
    renderBookingSummary();
    setFooterState();
  });
  bookingDate?.addEventListener('change', () => {
    setBookingDateValue(bookingDate.value);
  });
  bookingDatePrev?.addEventListener('click', () => setBookingDateValue(addDaysToDateValue(bookingDate?.value, -1)));
  bookingDateNext?.addEventListener('click', () => setBookingDateValue(addDaysToDateValue(bookingDate?.value, 1)));
  bookingDateList?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-booking-date-option]');
    if (!button) return;
    setBookingDateValue(button.dataset.bookingDateOption || '');
  });
  bookingEditServices?.addEventListener('click', () => setBookingStep(1));
  bookingSearchTimes?.addEventListener('click', () => searchAvailability({ force: true }));
  bookingBack?.addEventListener('click', () => setBookingStep(bookingStep - 1));
  bookingNext?.addEventListener('click', continueBooking);

  bookingProgress.forEach((button) => {
    button.addEventListener('click', () => {
      const nextStep = Number(button.dataset.bookingProgress || 0);

      if (bookingCreated) return;
      if (nextStep > 1 && !selectedLineItems().length) {
        if (bookingServiceStatus) {
          bookingServiceStatus.hidden = false;
          bookingServiceStatus.textContent = 'Choose an exact service before continuing.';
        }
        return;
      }
      if (nextStep > 2 && !providerSelectionReady()) return;
      if (nextStep > 3 && !allSlotsSelected()) return;
      if (nextStep > 4 && !hasDetails()) return;
      if (nextStep > 4 && cardCaptureRequired() && !squareToken) return;
      setBookingStep(nextStep);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (bookingDrawer.hidden) return;
    if (event.key === 'Escape' && bookingVariationModal && !bookingVariationModal.hidden) {
      closeVariationChooser();
      return;
    }
    if (event.key === 'Escape') closeBookingDrawer();
  });

  const autoOpenBookingDrawer = () => {
    if (!urlRequestsBooking() || !bookingDrawer.hidden) return;
    openBookingDrawer(document.querySelector('[data-booking-open]') || null);
  };

  const autoOpenBookingDrawerForEditor = () => {
    if (!editorPreviewEnabled || !bookingDrawer.hidden) return;
    openBookingDrawer(document.querySelector('[data-booking-open]') || null);
  };

  const updateBookingMediaParallax = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (bookingDrawer.dataset.asBookingParallax !== 'true') return;

    const amount = Number(bookingDrawer.dataset.asBookingParallaxAmount || 0);
    if (!amount) return;

    const panel = bookingDrawer.querySelector('.as-booking-drawer__visual');
    if (!panel || panel.offsetParent === null) return;

    const rect = panel.getBoundingClientRect();
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    const progress = (rect.top + rect.height / 2 - viewport / 2) / Math.max(viewport, 1);
    const offset = Math.max(-amount, Math.min(amount, progress * amount));
    const direction = bookingDrawer.dataset.asBookingParallaxDirection || 'vertical';

    bookingDrawer.style.setProperty('--as-booking-drawer-parallax-y', direction === 'horizontal' ? '0px' : `${offset.toFixed(2)}px`);
    bookingDrawer.style.setProperty('--as-booking-drawer-parallax-x', direction === 'horizontal' ? `${offset.toFixed(2)}px` : '0px');
  };

  const standaloneBookingApp = bookingDrawer.dataset.bookingStandalone === 'true' ||
    document.body.classList.contains('as-booking-app-shell');

  ensureBookingConfig().then(setFooterState);
  renderBookingSummary();
  if (standaloneBookingApp) {
    openBookingDrawer(document.querySelector('[data-booking-open]') || null);
  }
  window.requestAnimationFrame(autoOpenBookingDrawerForEditor);
  window.requestAnimationFrame(autoOpenBookingDrawer);
  window.addEventListener('hashchange', autoOpenBookingDrawer);
  window.addEventListener('scroll', updateBookingMediaParallax, { passive: true });
  window.addEventListener('resize', updateBookingMediaParallax);
  document.addEventListener('shopify:section:load', updateBookingMediaParallax);
})();
